/**
 * Português (brasileiro).
 *
 * As chaves vêm de `cs.js`. Se faltar alguma, aparece o texto em inglês
 * (e, na falta dele, em tcheco), então um buraco se percebe.
 *
 * Tradução ainda não revisada por uma pessoa trans falante nativa. O
 * vocabulário da transição e as formas de gênero importam aqui mais do que
 * em outros lugares: se algo soar errado, avise que a gente muda.
 */
const pt = {

  // ── společné ──────────────────────────────────────────────────────────────
  'obecne.zpet': 'Voltar',
  'obecne.hledat': 'Buscar',
  'obecne.nacitani': 'Carregando…',
  'obecne.zrusit': 'Cancelar',
  'obecne.ulozit': 'Salvar',
  'obecne.odeslat': 'Enviar',
  'obecne.vice': 'Ver tudo',
  'obecne.jazyk': 'Idioma',

  // ── přihlášení a registrace ───────────────────────────────────────────────
  'auth.podtitulek': 'Um espaço seguro para a comunidade trans, onde você pode falar abertamente, procurar ajuda e sentir o apoio das outras pessoas.',
  'auth.prihlaseni': 'Entrar',
  'auth.registrace': 'Criar conta',
  'auth.email': 'E-mail',
  'auth.heslo': 'Senha',
  'auth.emailPriklad': 'voce@exemplo.com',
  'auth.prihlasitSe': 'Entrar',
  'auth.prihlasuji': 'Entrando…',
  'auth.zapomenuteHeslo': 'Esqueceu a senha?',
  'auth.presGoogle': 'Entrar com o Google',
  'auth.spatneUdaje': 'E-mail ou senha incorretos',
  'auth.uspech': 'Você entrou.',
  'auth.googleChyba': 'Não foi possível entrar com o Google',
  'auth.obnoveniHesla': 'Redefinir a senha',
  'auth.obnoveniOdeslano': 'Se o e-mail estiver cadastrado, você vai receber um link para redefinir a senha.',
  'auth.zpetNaPrihlaseni': 'Voltar para o login',
  'auth.odeslatOdkaz': 'Enviar o link',
  'auth.obnoveniChyba': 'Não foi possível enviar o e-mail. Tente de novo.',

  // druhý krok přihlášení
  'auth.jesteKod': 'Mais um passo: seu código',
  'auth.jesteKodPopis': 'Abra seu aplicativo de autenticação e copie os seis dígitos que ele mostra para o Bloom.',
  'auth.kod': 'Código',
  'auth.zalozniKodNapoveda': 'Sem o celular por perto? Digite um dos códigos de reserva que você guardou ao ativar.',
  'auth.potvrdit': 'Confirmar',
  'auth.overuji': 'Verificando…',
  'auth.kodNesedi': 'Esse código não está certo',
  'auth.zalozniDochazeji': (p) => `Restam apenas ${p.pocet} códigos de reserva. Gere novos no seu perfil.`,

  // instalace a zabezpečení
  'auth.instalaceTitulek': 'Como instalar o Bloom no seu celular',
  'auth.krokyAndroid': [
      'Abra esta página no Chrome',
      'Toque no ícone de três pontos (⋮) no canto superior direito',
      'Escolha «Adicionar à tela inicial» ou «Instalar aplicativo»',
      'Confirme a instalação',
    ],
  'auth.krokyIos': [
      'Abra esta página no Safari',
      'Toque no ícone de compartilhar (□↑) na barra de baixo',
      'Desça e escolha «Adicionar à Tela de Início»',
      'Confirme tocando em «Adicionar»',
    ],
  'auth.seznamChranene': [
      { silne: 'Nada sobre quem participa é público.', text: 'Perfis, relatos, ofertas, perguntas, fotos e avatares só aparecem para quem entrou na conta. Nada disso pode ser baixado ou coletado sem uma conta.' },
      { silne: 'Ninguém sabe sua senha', text: '— nós também não. Ela é guardada como um hash bcrypt, do qual não dá para recuperar a original.' },
      { silne: 'As mensagens privadas e os anexos são criptografados', text: '(AES + verificação de integridade) já no disco do servidor. Quem conseguisse um backup ou o disco leria apenas caracteres sem sentido.' },
      { silne: 'As mensagens se apagam sozinhas', text: 'depois de um tempo (90 dias por padrão), inclusive áudios e fotos. O que não está aqui não vaza.' },
      { silne: 'Sua etapa de transição é privada', text: 'até você mesma publicá-la. Ninguém mais vê os passos que você marca no Guia.' },
      { silne: 'E-mail e telefone', text: 'nunca são mostrados a outras pessoas.' },
      { silne: '', text: 'O login é protegido contra tentativas de adivinhar a senha: o número de tentativas é limitado.' },
      { silne: 'Criptografia ponta a ponta das mensagens.', text: 'Quando você ativa, o texto e os anexos são criptografados no seu próprio navegador e o servidor recebe só caracteres ilegíveis. A chave se abre com a sua senha e nunca sai do seu aparelho — por isso nós também não conseguimos ler o conteúdo, nem se um tribunal pedisse. O preço é que, se você esquecer a senha, também não vai conseguir ler as mensagens antigas.' },
      { silne: '', text: 'A sessão não fica aberta: o Bloom desconecta você quando fecha a janela e depois de dez minutos sem uso.' },
    ],
  'auth.seznamNeumime': [
      { silne: 'Os metadados', text: '— quem escreveu para quem e quando — o servidor precisa saber para entregar a mensagem. A criptografia ponta a ponta não esconde isso, e o Signal também não.' },
      { silne: '', text: 'O Bloom é um aplicativo web, então ele baixa o código de criptografia do nosso servidor toda vez que você abre. Quem dominasse o servidor poderia, em tese, servir um código alterado. Só um aplicativo assinado de uma loja protege contra isso — por isso o Signal tem um e uma versão web não.' },
      { silne: 'Os perfis', text: '— apelido, descrição, avatar — não dá para criptografar, porque o servidor precisa mostrá-los para as outras pessoas.' },
      { silne: '', text: 'As mensagens anteriores à ativação da criptografia ficam criptografadas só no disco do servidor, não ponta a ponta.' },
    ],
  'auth.instalaceAndroid': 'Android',
  'auth.instalaceIos': 'iPhone / iPad',
  'auth.instalacePoznamka': 'O Bloom funciona como um aplicativo, mesmo sem internet. Seus dados estão sempre atualizados.',
  'auth.zabezpeceniTitulek': 'Como o Bloom é protegido',
  'auth.zabezpeceniUvod': 'O Bloom é um espaço para a comunidade trans, então coisas delicadas se encontram aqui. Abaixo está o que '
      + 'fazemos para protegê-las — e o que não conseguimos fazer — sem enfeitar.',
  'auth.coJeChranene': 'O que está protegido',
  'auth.coNeumime': 'O que o Bloom não consegue fazer — e é justo dizer',
  'auth.zabezpeceniZaver': 'Se você tiver alguma dúvida sobre privacidade ou encontrar uma falha, use «Relatar um problema» abaixo. Levamos isso a sério.',
  'auth.mvp': 'O Bloom está na primeira versão e vamos melhorando junto com a comunidade. '
      + 'Se você encontrar um erro ou tiver uma ideia, vai ser bom saber.',
  'auth.nahlasitProblem': 'Relatar um problema',
  'auth.clenu': (p) => (p.pocet === 1 ? 'pessoa' : 'pessoas'),
  'auth.prispevku': (p) => (p.pocet === 1 ? 'publicação' : 'publicações'),
  'auth.odborniku': (p) => (p.pocet === 1 ? 'profissional' : 'profissionais'),
  'auth.nabidek': (p) => (p.pocet === 1 ? 'oferta' : 'ofertas'),

  // ── registrace ────────────────────────────────────────────────────────────
  'reg.prezdivka': 'Apelido (único)',
  'reg.prezdivkaPriklad': 'Pelo menos 3 caracteres',
  'reg.telefon': 'Telefone',
  'reg.volitelne': '(opcional)',
  'reg.heslo': 'Senha',
  'reg.hesloZnovu': 'Repita a senha',
  'reg.zajmeno': 'Pronomes',
  'reg.oMne': 'Sobre mim',
  'reg.oMnePriklad': 'Algumas palavras sobre você…',
  'reg.registrovat': 'Criar conta',
  'reg.registruji': 'Criando a conta…',
  'reg.presGoogle': 'Cadastrar-se com o Google',
  'reg.avatar': 'Avatar',
  'reg.neboFoto': 'Ou envie a sua própria foto',
  'reg.nahratFoto': 'Enviar foto',
  'reg.vlastni': 'Própria',
  'reg.zeme': 'País',
  'reg.kraj': 'Região',
  'reg.nechciUvadet': 'Prefiro não dizer',
  'reg.cesko': 'Tchéquia',
  'reg.svet': 'Resto do mundo',

  // skupiny avatarů
  'reg.avatarFem': 'Femininos',
  'reg.avatarMask': 'Masculinos',
  'reg.avatarNeutr': 'Neutros',
  'reg.avatarZvirata': 'Animais',

  // komunitní heslo
  'reg.komunitniHeslo': 'Senha da comunidade',
  'reg.komunitniHesloPriklad': 'Digite a senha da comunidade…',
  'reg.komunitniHesloPopis': 'O Bloom é um espaço privado para a comunidade trans. Alguém da comunidade pode te passar a senha.',
  'reg.napisAdminovi': 'Se você não conhece ninguém, escreva para a administração em',
  'reg.nevimHeslo': 'Não sei a senha da comunidade',
  'reg.jakZiskat': 'A senha da comunidade protege este espaço privado. Como conseguir:',
  'reg.krok1': '1. Escreva um e-mail para',
  'reg.krok2': '2. Se apresente rapidamente e conte como ficou sabendo do Bloom',
  'reg.krok3': '3. A administração responde assim que puder',

  // kontrola hesla
  'reg.hesloKratke': 'A senha precisa ter pelo menos 8 caracteres',
  'reg.hesloMale': 'A senha precisa ter uma letra minúscula',
  'reg.hesloVelke': 'A senha precisa ter uma letra maiúscula',
  'reg.hesloCislo': 'A senha precisa ter um número',
  'reg.hesloZnak': 'A senha precisa ter um caractere especial (!@#$%…)',
  'reg.pozadavek8': 'Pelo menos 8 caracteres',
  'reg.pozadavekVelke': 'Letra maiúscula',
  'reg.pozadavekCislo': 'Número',
  'reg.pozadavekZnak': 'Caractere especial (!@#$%)',
  'reg.hesloNesouhlasi': 'As senhas não são iguais',
  'reg.prezdivkaKratka': 'O apelido precisa ter pelo menos 3 caracteres',
  'reg.hesloPovinne': 'A senha da comunidade é obrigatória',
  'reg.hotovo': 'Conta criada. Confira seu e-mail para confirmá-la.',
  'reg.fotoVelka': 'A imagem é grande demais (máx. 2 MB)',
  'reg.chyba': 'Não foi possível criar a conta',

  // ── domovská stránka ──────────────────────────────────────────────────────
  'domu.citat': 'Aqui ninguém precisa ser perfeita. O Bloom é um espaço onde cada pessoa pode ser quem é — '
      + 'onde você pode compartilhar sua experiência, perguntar e ajudar as outras. Sem julgamento e sem preconceito.',
  'domu.citatAutor': '— Martina Sobková',
  'domu.prelozenoZCestiny': ' · traduzido do tcheco',
  'domu.vitej': 'Olá,',
  'domu.vCislech': 'O Bloom em números',
  'domu.noveVKomunite': 'É sua primeira vez?',
  'domu.noveVKomunitePopis1': 'Você não precisa aparecer. Não precisa de foto. Não precisa estar fora do armário.',
  'domu.noveVKomunitePopis2': 'O Bloom é um espaço onde você pode começar no seu ritmo.',
  'domu.rozcestnik1': 'É minha primeira vez aqui',
  'domu.rozcestnik2': 'Não sei por onde começar',
  'domu.rozcestnik3': 'Quero ficar anônima',
  'domu.rozcestnik4': 'Procuro profissionais',
  'domu.rozcestnik5': 'Só quero ler experiências',
  'domu.otazky': 'Dúvidas ou quer saber mais? Escreva para',
  'domu.doporucujeme': 'Recomendado',
  'domu.odbornici': 'Profissionais',
  'domu.noviClenove': 'Pessoas novas na comunidade',
  'domu.zadniNovi': 'Ainda não chegou ninguém',
  'domu.nejnovejsiOtazky': 'Últimas perguntas',
  'domu.zadneOtazky': 'Ainda não há perguntas.',
  'domu.nejlepeHodnoceni': 'Profissionais mais bem avaliados',
  'domu.zadniHodnoceni': 'Ainda não há avaliações',
  'domu.zadneAktuality': 'Ainda não há notícias',

  // dlaždice sekcí
  'domu.dlazdice.support': 'Ofereça o que você sabe fazer e receba ajuda das outras pessoas.',
  'domu.dlazdice.specialists': 'Encontre profissionais verificados, da psicologia à cirurgia plástica.',
  'domu.dlazdice.legal': 'Ajuda jurídica, artigos e respostas às suas perguntas.',
  'domu.dlazdice.nearby': 'Serviços e profissionais perto de você.',

  // počty
  'domu.pocetClenu': (p) => (p.pocet === 1 ? 'pessoa na comunidade' : 'pessoas na comunidade'),
  'domu.pocetZkusenosti': (p) => (p.pocet === 1 ? 'experiência compartilhada' : 'experiências compartilhadas'),
  'domu.pocetOdborniku': (p) => (p.pocet === 1 ? 'profissional verificado' : 'profissionais verificados'),
  'domu.pocetNabidek': (p) => (p.pocet === 1 ? 'oferta de apoio mútuo' : 'ofertas de apoio mútuo'),

  // ── navigace a společné ovládání ──────────────────────────────────────────
  'nav.domu': 'Início',
  'nav.news': 'Notícias',
  'nav.stories': 'Experiências da comunidade',
  'nav.mapaSveta': 'Mapa do mundo',
  'nav.support': 'Apoio mútuo',
  'nav.specialists': 'Profissionais trans-friendly',
  'nav.legal': 'Ajuda jurídica',
  'nav.pageants': 'Concursos',
  'nav.nearby': 'Perto de mim',
  'nav.hledat': 'Buscar no Bloom',
  'nav.hledatPlaceholder': 'Buscar pessoas, profissionais, artigos…',
  'nav.zpravy': 'Mensagens',
  'nav.profil': 'Meu perfil',
  'nav.mojeCesta': 'Meu caminho',
  'nav.administrace': 'Administração',
  'nav.odhlasit': 'Sair',
  'nav.vsechnyVysledky': (p) => `Ver todos os resultados de «${p.dotaz}»`,
  'nav.overEmail': 'Confirme seu e-mail',
  'nav.menu': 'Menu',

  // ── mapa světa ────────────────────────────────────────────────────────────
  'svet.titulek': 'O Bloom pelo mundo',
  'svet.podtitulek': 'Escolha um país e veja o que a comunidade juntou por lá.',
  'svet.hledatZemi': 'Buscar um país…',
  'svet.vsechnyZeme': 'Todos os países',
  'svet.jenSObsahem': 'Só países com conteúdo',
  'svet.nicNenalezeno': 'Nenhum país corresponde.',
  'svet.zaznamu': (p) => `${p.pocet} ${p.pocet === 1 ? 'registro' : 'registros'}`,
  'svet.prazdnaZeme': 'Ainda nada',
  'svet.kontinent': 'Continente',
  'svet.celySvet': 'Mundo inteiro',
  'svet.vse': 'Tudo',
  'svet.zacniDomovem': 'Comece escolhendo o país onde você mora. Também dá para escolher na lista abaixo do mapa.',
  'svet.zkoumej': 'Escolha um país e veja o que o Bloom tem lá. Você pode olhar onde quiser — '
      + 'isso não muda o seu país.',
  'svet.domov': 'Casa',
  'svet.zrusitDomov': 'Tirar o país de residência',
  'svet.nastavitDomov': 'Definir como o meu país',
  'svet.zeSveta': 'Pelo mundo',
  'svet.coSeChysta': 'O que vem aí',
  'svet.souteze': 'Concursos com inscrições abertas',
  'svet.noveOrganizace': 'Organizações novas',
  'svet.kdeJizNeco': 'Onde o Bloom já tem algo',
  'svet.hledatZemiPopisek': 'Buscar um país',
  'svet.nicNeodpovida': 'Nada corresponde. Tente outra busca.',
  'svet.napovedaKMape': 'Arraste o mapa para movê-lo e use a roda ou os botões para aproximar. Você não '
      + 'precisa usá-lo: a busca e a lista completa de países estão abaixo.',
  'svet.tvujBloom': (p) => `Seu Bloom em ${p.zeme}`,
  'svet.tvojeDomovska': 'seu país de residência',
  'svet.zemi': (p) => `${p.pocet} ${p.pocet === 1 ? 'país' : 'países'}`,
  'svet.chyba': 'Não foi possível carregar os países. Recarregue a página.',
  'svet.pocet.specialists': (p) => `${p.pocet} ${p.pocet === 1 ? 'profissional' : 'profissionais'}`,
  'svet.pocet.organizations': (p) => `${p.pocet} ${p.pocet === 1 ? 'organização' : 'organizações'}`,
  'svet.pocet.events': (p) => `${p.pocet} ${p.pocet === 1 ? 'evento' : 'eventos'}`,
  'svet.pocet.pageants': (p) => `${p.pocet} ${p.pocet === 1 ? 'concurso' : 'concursos'}`,
  'svet.pocet.resources': (p) => `${p.pocet} ${p.pocet === 1 ? 'recurso' : 'recursos'}`,

  // světadíly
  'kontinent.europe': 'Europa',
  'kontinent.asia': 'Ásia',
  'kontinent.africa': 'África',
  'kontinent.north_america': 'América do Norte',
  'kontinent.south_america': 'América do Sul',
  'kontinent.oceania': 'Oceania',
  'kontinent.antarctica': 'Antártida',

  // ── soutěže napříč světem ─────────────────────────────────────────────────
  'souteze.podtitulek': 'Concursos trans do mundo inteiro. Os que ainda aceitam inscrição estão no topo.',
  'souteze.hledat': 'Buscar um concurso…',
  'souteze.zadne': 'Ainda não temos concursos. Conhece algum? Mande uma sugestão.',

  // ── náhled země pod mapou ─────────────────────────────────────────────────
  'nahled.otevrit': (p) => `Abrir ${p.zeme}`,
  'nahled.zavrit': 'Fechar a prévia',
  'nahled.jenInformace': 'Por enquanto só temos informações sobre o país.',
  'nahled.zatimNic': 'Ainda não temos aqui contatos, organizações nem eventos. Conhece algo? Mande uma sugestão.',
  // ── stránka země ──────────────────────────────────────────────────────────
  'zeme.titulek': (p) => `Bloom em ${p.zeme}`,
  'zeme.podtitulek': (p) => `O que a comunidade juntou em ${p.zeme}.`,
  'zeme.prazdna': 'O Bloom está começando por aqui. Você poderia ser a primeira pessoa a acrescentar algo.',
  'zeme.mapaSveta': 'Mapa do mundo',
  'zeme.navrhnout': 'Sugerir um registro',
  'zeme.domovska': 'Seu país de residência',
  'zeme.nastavitDomovskou': 'Definir como o meu país',
  'zeme.kdeToJe': 'Onde encontrar',
  'zeme.coTuBude': 'O que você vai encontrar aqui',
  'zeme.zatimPrazdne': 'vazio por enquanto',
  'zeme.pripravujeme': 'em preparação',
  'zeme.zobrazitVse': (p) => `Ver tudo (${p.pocet})`,
  'zeme.rosteTitulek': 'O Bloom está só começando por aqui',
  'zeme.rostePopis': 'Ainda não temos nada aqui. Você conhece uma organização, um evento ou um '
      + 'contato útil? Mande uma sugestão: ela passa por revisão e depois aparece aqui.',
  'zeme.jinouZemi': 'Ver outros países',
  'zeme.bezKontaktu': 'Ainda não temos aqui contatos nem organizações.',
  'zeme.bezKontaktuPopis': 'Conhece alguém ou algo útil por aqui? Mande uma sugestão: ela passa por '
      + 'revisão e depois aparece aqui.',
  'zeme.neznama': 'Não conhecemos esse país.',
  'zeme.chyba': 'Não foi possível carregar o país.',

  // ── sekce ─────────────────────────────────────────────────────────────────
  'sekce.specialists': 'Consultórios e clínicas',
  'sekce.specialists.popis': 'Profissionais de saúde, clínicas e outras pessoas com quem a comunidade tem experiência.',
  'sekce.organizations': 'Organizações',
  'sekce.organizations.popis': 'Associações, entidades sem fins lucrativos e grupos de apoio.',
  'sekce.events': 'Eventos',
  'sekce.events.popis': 'Encontros, Paradas, oficinas e congressos.',
  'sekce.pageants': 'Concursos',
  'sekce.pageants.popis': 'Concursos trans e suas datas.',
  'sekce.resources': 'Recursos',
  'sekce.resources.popis': 'Informações práticas sobre este país.',
  'sekce.community': 'Comunidade',
  'sekce.community.popis': 'Pessoas e grupos deste país.',
  'sekce.legal': 'Ajuda jurídica',
  'sekce.legal.popis': 'Informação e apoio para a comunidade trans',
  'sekce.support': 'Apoio mútuo',
  'sekce.support.popis': 'Ofereça o que você sabe fazer e receba ajuda de outras pessoas da comunidade',

  // ── výpis záznamů ─────────────────────────────────────────────────────────
  'vypis.hledatVZemi': 'Buscar neste país…',
  'vypis.vsechnyKategorie': 'Todas as categorias',
  'vypis.kategorie': 'Categoria',
  'vypis.celaZeme': 'O país inteiro',
  'vypis.navrhnout': 'Sugerir',
  'vypis.nicNeodpovida': 'Nada corresponde. Tente outra busca ou tire o filtro.',
  'vypis.zadneZaznamy': (p) => `Ainda não temos registros em ${p.zeme}.`,
  'vypis.zaznamu': (p) => `${p.pocet} ${p.pocet === 1 ? 'registro' : 'registros'}`,
  'vypis.predchozi': 'Anterior',
  'vypis.dalsi': 'Próximo',
  'vypis.chyba': 'Não foi possível carregar os registros.',
  'vypis.neznamyDruh': 'Não conhecemos esse tipo de registro.',

  // ── detail záznamu ────────────────────────────────────────────────────────
  'detail.zpetNa': (p) => `Voltar para ${p.zeme}`,
  'detail.kontakty': 'Contato e links',
  'detail.podrobnosti': 'Detalhes',
  'detail.zacatek': 'Começa',
  'detail.termin': 'Data',
  'detail.uzaverka': 'Prazo de inscrição',
  'detail.prihlaska': 'Inscrição',
  'detail.strankaAkce': 'Página do evento',
  'detail.web': 'Site',
  'detail.konec': 'Termina',
  'detail.stavRocniku': 'Situação da edição',
  'detail.oblasti': 'Áreas de atuação',
  'detail.coNabizi': 'O que oferecem',
  'detail.kategorie': 'Categorias',
  'detail.jazyky': 'Idiomas',
  'detail.vitezove': 'Vencedoras anteriores',
  'detail.kdoSeMuze': 'Quem pode participar',
  'detail.poradatel': 'Organização',
  'detail.poplatek': 'Taxa',
  'detail.tema': 'Tema',
  'detail.forma.offline': 'Presencial',
  'detail.forma.online': 'On-line',
  'detail.forma.hybrid': 'Presencial e on-line',
  'detail.rozsah.local': 'Local',
  'detail.rozsah.national': 'Nacional',
  'detail.rozsah.international': 'Internacional',
  'detail.rocnik.upcoming': 'Em breve',
  'detail.rocnik.registration_open': 'Inscrições abertas',
  'detail.rocnik.registration_closed': 'Inscrições encerradas',
  'detail.rocnik.completed': 'Realizado',
  'detail.zdroj': (p) => `Fonte: ${p.zdroj}`,
  'detail.upraveno': (p) => `Última atualização: ${p.datum}`,
  'detail.overeno': 'Verificado que a informação confere. Não é uma recomendação do Bloom.',
  'detail.neovereno': 'Este registro ainda não foi verificado. Os dados podem ter mudado: confira na fonte.',
  'detail.nenalezen': 'Não conhecemos esse registro. Pode ter sido apagado ou ainda estar em revisão.',
  'detail.chyba': 'Não foi possível carregar o registro.',

  // ── profil země ───────────────────────────────────────────────────────────
  'profil.coTuPlati': 'O que vale aqui',
  'profil.name_change': 'Mudança de nome',
  'profil.gender_marker': 'Mudança do sexo nos documentos',
  'profil.surgery_required': 'Exigência de cirurgia',
  'profil.healthcare': 'Acesso à saúde',
  'profil.legal_protection': 'Proteção contra discriminação',
  'profil.safety': 'Segurança',
  'profil.stav.yes': 'Sim',
  'profil.stav.limited': 'Em parte',
  'profil.stav.no': 'Não',
  'profil.stav.unknown': 'Sem informação',
  'profil.zdroj': 'Fonte',
  'profil.zdrojZRoku': (p) => `fonte de ${p.rok}`,
  'profil.overeno': (p) => `Verificado em ${p.datum}`,
  'profil.zmena': 'Mudança recente',
  'profil.odKdy': (p) => `em vigor desde ${p.datum}`,
  'profil.doklady': 'Fontes',
  'profil.zakon': 'lei ou decisão judicial',
  'profil.upozorneni': 'Isto não é orientação jurídica. As leis mudam e muita coisa depende da sua '
      + 'situação específica: confira na fonte ou com uma organização daquele '
      + 'país antes de agir.',

  // ── formulář návrhu ───────────────────────────────────────────────────────
  'navrh.titulek': (p) => `Sugerir ${p.druh}${p.zeme ? ` — ${p.zeme}` : ''}`,
  'navrh.popisFormulare': 'Sua sugestão passa por revisão antes de aparecer no Bloom. Preencha o que '
      + 'você sabe: o resto a gente completa.',
  'navrh.jednotne.organizations': 'uma organização',
  'navrh.jednotne.events': 'um evento',
  'navrh.jednotne.pageants': 'um concurso',
  'navrh.jednotne.resources': 'um recurso',
  'navrh.popis.organizations': 'Uma associação, uma entidade sem fins lucrativos ou um grupo de apoio.',
  'navrh.popis.events': 'Um encontro, uma Parada, uma oficina, um congresso.',
  'navrh.popis.pageants': 'Um concurso trans: data, inscrição, quem organiza.',
  'navrh.popis.resources': 'Informação prática: saúde, direito, documentos, contatos.',
  'navrh.nazev': 'Nome',
  'navrh.popisPole': 'Descrição',
  'navrh.zeme': 'País',
  'navrh.mesto': 'Cidade',
  'navrh.adresa': 'Endereço',
  'navrh.web': 'Site',
  'navrh.email': 'E-mail',
  'navrh.telefon': 'Telefone',
  'navrh.odkudVis': 'De onde você sabe',
  'navrh.odkudVisPriklad': 'p. ex. do site deles, eu estive lá…',
  'navrh.vyberte': '— escolha —',
  'navrh.forma': 'Formato',
  'navrh.rozsah': 'Alcance',
  'navrh.platiPro': 'Vale para',
  'navrh.platnost.global': 'O mundo inteiro',
  'navrh.platnost.country': 'Um país',
  'navrh.platnost.region': 'Uma região',
  'navrh.platnost.city': 'Uma cidade',
  'navrh.odkazAkce': 'Link do evento',
  'navrh.odkazPrihlaska': 'Link da inscrição',
  'navrh.odkazy': 'Links',
  'navrh.text': 'Texto',
  'navrh.odeslat': 'Enviar a sugestão',
  'navrh.odesilam': 'Enviando…',
  'navrh.chyba': 'Não foi possível enviar a sugestão',
  'navrh.dikyTitulek': 'Obrigada, já anotamos',
  'navrh.dikyPopis': 'Recebemos a sua sugestão. Alguém vai revisar e depois ela aparece '
      + 'no Bloom. Nada é publicado automaticamente.',
  'navrh.zavrit': 'Fechar',
  'navrh.seznamNapoveda': 'Separe os itens por vírgulas.',

  // ── převzetí profilu ──────────────────────────────────────────────────────
  'prevzeti.patriVam': (p) => `${p.druh} é sua?`,
  'prevzeti.popis': 'Você pode assumir o perfil e manter os dados em dia. '
      + 'O pedido passa primeiro por revisão.',
  'prevzeti.tlacitko': 'Assumir este perfil',
  'prevzeti.spravujes': 'Você administra este perfil. Pode corrigir os dados quando quiser: as mudanças valem na hora.',
  'prevzeti.upravit': 'Editar os dados',
  'prevzeti.spravujeSama': (p) => `Este perfil é administrado pela própria ${p.druh}.`,
  'prevzeti.ceka': 'Recebemos o seu pedido e estamos analisando.',
  'prevzeti.formulacTitulek': (p) => `Assumir o perfil — ${p.nazev}`,
  'prevzeti.formulacPopis': 'Antes de entregar o perfil, precisamos saber que você faz parte mesmo da '
      + 'organização. O pedido passa por revisão; por enquanto nada muda.',
  'prevzeti.role': 'Qual é o seu papel lá?',
  'prevzeti.rolePriklad': 'p. ex. coordenação, presidência da associação',
  'prevzeti.doklad': 'Como podemos verificar isso?',
  'prevzeti.dokladPriklad': 'p. ex. apareço no site da organização, nos contatos; ou escreva de um endereço oficial',
  'prevzeti.dokladNapoveda': 'Basta um link para uma página onde você aparece, ou o endereço oficial '
      + 'da organização para escrever de lá.',
  'prevzeti.kontakt': 'Seu contato',
  'prevzeti.kontaktPriklad': 'e-mail ou telefone',
  'prevzeti.dalsi': 'Mais alguma coisa',
  'prevzeti.nepovinne': '(opcional)',
  'prevzeti.odeslat': 'Enviar o pedido',
  'prevzeti.odesilam': 'Enviando…',
  'prevzeti.vyplnObe': 'Conte qual é o seu papel e como isso pode ser verificado.',
  'prevzeti.prijato': 'Obrigada. Recebemos o seu pedido e vamos responder.',
  'prevzeti.chyba': 'Não foi possível enviar o pedido.',
  'prevzeti.upravaTitulek': (p) => `Editar o perfil — ${p.nazev}`,
  'prevzeti.upravaPopis': 'O nome e o local não estão aqui de propósito: os registros são buscados e '
      + 'ordenados por eles. Se mudaram, escreva para a gente e atualizamos.',
  'prevzeti.popisPole': 'Descrição',
  'prevzeti.email': 'E-mail',
  'prevzeti.telefon': 'Telefone',
  'prevzeti.web': 'Site',
  'prevzeti.ulozeno': 'Salvo.',
  'prevzeti.ukladam': 'Salvando…',
  'prevzeti.chybaUlozeni': 'Não foi possível salvar.',
  'prevzeti.druh.organizations': 'a organização',
  'prevzeti.druh.events': 'o evento',
  'prevzeti.druh.pageants': 'o concurso',

  // ── profil ────────────────────────────────────────────────────────────────
  'profil.upravteUdaje': 'Edite seus dados e ajustes',
  'profil.overeny': 'Confirmado',
  'profil.neovereny': 'Não confirmado',
  'profil.overteEmail': 'Confirme seu e-mail. Uma conta não confirmada tem permissões limitadas.',
  'profil.emailOdeslan': 'E-mail de confirmação enviado.',
  'profil.emailChyba': 'Não foi possível enviar o e-mail',
  'profil.odeslano': 'Enviado.',
  'profil.overeniOdbornika': 'Verificação como profissional ou advogada',
  'profil.pracujeteVOboru': 'Você trabalha na área? Ganhe um selo de verificação.',
  'profil.zadostOdeslana': 'Pedido enviado',
  'profil.pozadatOOvereni': 'Pedir verificação',
  'profil.zadostTitulek': 'Pedir verificação como profissional ou advogada',
  'profil.zadostPopis': 'Preencha os dados do seu pedido. A moderação vai analisar.',
  'profil.pozadovanaRole': 'Papel pedido',
  'profil.roleOdbornik': 'Profissional',
  'profil.rolePravnik': 'Advocacia',
  'profil.specializace': 'Especialidade',
  'profil.odkazNaProfil': 'Link para um perfil profissional',
  'profil.zpravaProAdmina': 'Uma mensagem curta para a administração',
  'profil.odesilam': 'Enviando…',
  'profil.odeslatZadost': 'Enviar o pedido de verificação',
  'profil.vyplnteSpecializaci': 'Preencha sua especialidade',
  'profil.zadostUspech': 'Seu pedido de verificação foi enviado.',
  'profil.zadostChyba': 'Não foi possível enviar o pedido',

  // bezpečnost
  'bezp.titulek': 'Segurança',
  'bezp.sifrovaniZapnuto': (p) => `A criptografia das mensagens está ligada${p.odemceno ? ' e destravada' : ' (travada nesta aba)'}.`,
  'bezp.sifrovaniVypnuto': 'Você ainda não ligou a criptografia das mensagens.',
  'bezp.sifrovaniKde': 'Ela se liga e se destrava na página de Mensagens.',
  'bezp.sifrovaniKdeVypnute': 'Você pode ligar na página de Mensagens, em qualquer conversa.',
  'bezp.zmenaHesla': 'Trocar a senha',
  'bezp.zmenaHeslaSifrovani': 'Com a criptografia ligada, trocar a senha também reembrulha a chave das suas mensagens. '
      + 'Por isso a senha atual é necessária: sem ela a chave não abriria e você perderia as mensagens.',
  'bezp.stavajiciHeslo': 'Senha atual',
  'bezp.noveHeslo': 'Nova senha',
  'bezp.noveHesloZnovu': 'Repita a nova senha',
  'bezp.pozadavky': 'Pelo menos 8 caracteres, maiúsculas e minúsculas, um número e um caractere especial.',
  'bezp.zmenitHeslo': 'Trocar a senha',
  'bezp.menim': 'Trocando…',
  'bezp.hesloNeshoda': 'As novas senhas não são iguais.',
  'bezp.vyplnObe': 'Preencha as duas senhas.',
  'bezp.stareNesedi': 'A senha atual não está certa: a chave das suas mensagens se perderia, então nada foi trocado.',
  'bezp.zmenenoSKlicem': 'Senha trocada. A chave das suas mensagens foi reembrulhada, então as mensagens antigas continuam legíveis.',
  'bezp.zmeneno': 'Senha trocada.',
  'bezp.zmenaChyba': 'Não foi possível trocar a senha.',
  'bezp.nepamatujes': 'Não lembra a senha da chave?',
  'bezp.zahoditPopis': 'Você pode descartar a chave e começar de novo. As mensagens criptografadas até agora se perdem para sempre: '
      + 'ninguém consegue lê-las, nós também não. E é exatamente por isso que é seguro.',
  'bezp.zahodit': 'Descartar as chaves e começar de novo',
  'bezp.zahoditPotvrzeni': 'Descartar mesmo as chaves?\n\nTodas as mensagens criptografadas até agora se perdem para sempre: '
      + 'ninguém consegue lê-las, nós também não. Faça isso só se você não lembra da senha '
      + 'que usou ao ligar a criptografia.',
  'bezp.klicSmazan': 'Chaves apagadas. Recarregue a página.',
  'bezp.nepovedlo': 'Não deu certo.',
  'bezp.prohlizecNeumi': 'Este navegador não suporta a criptografia que o Bloom usa.',

  'profil.mujProfil': 'Meu perfil',
  'profil.specializacePriklad': 'p. ex. psicologia, sexologia, advocacia…',
  'profil.zpravaPriklad': 'Por exemplo um link para o seu registro profissional ou para o site do consultório…',
  'profil.overeniUvod': 'Quer ser profissional ou advogada verificada no Bloom? Mande um pedido de verificação. '
      + 'Seu perfil precisa bater com a sua profissão de verdade.',

  'profil.oborPriklad': 'p. ex. cirurgia plástica, direito de família…',
  'profil.nepovinnyText': 'Observação extra, opcional…',
  // ── dvoufázové přihlášení ─────────────────────────────────────────────────
  'dvf.titulek': 'Verificação em duas etapas',
  'dvf.zapnuto': (p) => `Ligada. Restam ${p.pocet} códigos de reserva.`,
  'dvf.vypnuto': 'Além da senha, você digita um código de seis dígitos de um aplicativo no seu celular.',
  'dvf.chraniA': 'Protege',
  'dvf.chraniPrihlaseni': 'o login',
  'dvf.chraniB': ': quem souber sua senha mas não tiver seu celular não consegue entrar.',
  'dvf.nechrani': 'Não protege as mensagens criptografadas',
  'dvf.nechraniPopis': ' — essas se abrem com a sua senha no seu próprio navegador, sem o servidor.',
  'dvf.ulozKody': 'Guarde estes dez códigos de reserva',
  'dvf.ulozKodyPopis1': 'Cada um funciona uma vez só, e são o único jeito de entrar se você perder o celular.',
  'dvf.znovuNeukaze': 'Ninguém vai mostrá-los de novo',
  'dvf.ulozKodyPopis2': ' — guardamos apenas o hash deles.',
  'dvf.zkopirovat': 'Copiar',
  'dvf.ulozilaJsem': 'Já guardei',
  'dvf.zkopirovano': 'Copiado.',
  'dvf.kopieChyba': 'Não deu para copiar, anote à mão.',
  'dvf.zapnout': 'Ligar a verificação em duas etapas',
  'dvf.pripravuji': 'Preparando…',
  'dvf.nactiKod': 'Escaneie este código num aplicativo de autenticação — por exemplo Google Authenticator, Authy, 1Password ou Aegis.',
  'dvf.qrNejde': 'Não consegue escanear o QR code?',
  'dvf.zadejRucne': 'Digite esta chave no aplicativo à mão:',
  'dvf.opisKod': 'Digite o código que o aplicativo mostra',
  'dvf.zapnoutKratce': 'Ligar',
  'dvf.overuji': 'Verificando…',
  'dvf.noveKody': 'Novos códigos de reserva',
  'dvf.vypnout': 'Desligar',
  'dvf.noveKodyPopis': 'O novo conjunto substitui o antigo: seus códigos de reserva atuais param de funcionar.',
  'dvf.kodZAplikace': 'Código do aplicativo',
  'dvf.vygenerovat': 'Gerar',
  'dvf.vypnutiPopis': 'Para desligar são precisos a sua senha e um código válido. Os dois de propósito: senão qualquer pessoa com acesso a um navegador aberto poderia tirar.',
  'dvf.kodNeboZalozni': 'Código do aplicativo ou código de reserva',
  'dvf.vypinam': 'Desligando…',
  'dvf.vypnoutCele': 'Desligar a verificação em duas etapas',
  'dvf.vypnuto2': 'Verificação em duas etapas desligada.',
  'dvf.kodNesedi': 'Esse código não está certo.',
  'dvf.nepovedlo': 'Não deu certo.',

  // ── formulář profilu ──────────────────────────────────────────────────────
  'pf.ulozeno': 'Perfil atualizado.',
  'pf.chyba': 'Não foi possível atualizar o perfil',
  'pf.fotkaNahrana': 'Foto enviada.',
  'pf.fotkaChyba': 'Não foi possível enviar a imagem',
  'pf.fotkaVelka': 'A imagem é grande demais (máx. 5 MB)',
  'pf.oznameniUlozeno': 'Ajustes de notificações salvos.',
  'pf.oznameniChyba': 'Não foi possível salvar os ajustes',
  'pf.zruseno': 'Seu perfil foi apagado',
  'pf.zruseniChyba': 'Não foi possível apagar o perfil',
  'pf.zruseniPotvrzeni': 'Quer mesmo apagar seu perfil? Isso não dá para desfazer e todos os seus dados serão apagados.',
  'pf.urlFacebook': 'O endereço do Facebook precisa começar com https://',
  'pf.urlInstagram': 'O endereço do Instagram precisa começar com https://',
  'pf.urlLinkedin': 'O endereço do LinkedIn precisa começar com https://',
  'pf.ukladam': 'Salvando…',
  'pf.ulozitOznameni': 'Salvar os ajustes de notificações',
  'pf.oznameniZpravy': 'Mensagens privadas',
  'pf.oznameniAdmin': 'Nova mensagem da administração',
  'pf.oznameniUzivatel': 'Nova mensagem de outra pessoa',
  'pf.oznameniPodpora': 'Nova publicação em Apoio mútuo',
  'pf.oznameniNabidky': 'Ofertas e pedidos',

  // odznaky
  'pf.odznakAdmin': 'Administração',
  'pf.odznakPravnik': 'Advocacia',
  'pf.odznakSpecialista': 'Profissional verificado',
  'pf.odznakClen': 'Pessoa verificada da comunidade',
  'pf.odznakPomocnik': 'Ajuda ativa',
  'pf.odznakDuveryhodny': 'Pessoa de confiança',

  // ── galerie ───────────────────────────────────────────────────────────────
  'gal.pridano': 'Foto adicionada à galeria.',
  'gal.smazano': 'Foto apagada',
  'gal.hesloKratke': 'A senha da galeria precisa ter pelo menos 4 caracteres',
  'gal.nahraniChyba': 'Não foi possível enviar a foto',
  'gal.mazaniChyba': 'Não foi possível apagar a foto',
  'gal.souborVelky': 'O arquivo é grande demais (máx. 5 MB)',
  'gal.ulozitNastaveni': 'Salvar os ajustes',
  'gal.hesloPopis': 'Quem visitar vai precisar digitar esta senha para ver a galeria.',
  'gal.pridat': 'Adicionar foto ou vídeo',
  'gal.prazdna': 'Ainda não há fotos na galeria',

  // ── moje cesta ────────────────────────────────────────────────────────────
  'cesta.kdeJsem': 'Onde estou agora?',
  'cesta.popis': 'Compartilhe sua etapa de transição se quiser — ou guarde só para você.',
  'cesta.soukroma': 'Sua etapa é privada',
  'cesta.viditelna': 'Sua etapa é visível para as outras pessoas',
  'cesta.jenTy': 'Só você vê a sua etapa',
  'cesta.mohouNajit': 'As outras pessoas podem te encontrar por «Achar pessoas numa etapa parecida»',
  'cesta.poznamka': 'Nota pessoal',
  'cesta.volitelna': '(opcional)',
  'cesta.poznamkaPriklad': 'O que você quiser compartilhar ou lembrar…',
  'cesta.najitPodobne': 'Achar pessoas numa etapa parecida',
  'cesta.hledam': 'Buscando…',
  'cesta.ulozit': 'Salvar o meu caminho',
  'cesta.ulozeno': 'Seu caminho foi salvo.',
  'cesta.vyberteFazi': 'Escolha uma etapa',
  'cesta.chyba': 'Não foi possível salvar',

  'pf.socialniSite': 'Redes sociais',
  'pf.avatarFoto': 'Avatar / foto de perfil',
  'pf.nahratProfilni': 'Enviar foto de perfil',
  'pf.zrusitProfil': 'Apagar o perfil',
  'pf.nastaveniOznameni': 'Ajustes de notificações',
  'pf.nastaveniOznameniPopis': 'Escolha sobre o que quer receber avisos.',
  'gal.overEmail': 'Para enviar fotos, confirme antes o seu e-mail.',
  'cesta.coMeCeka': 'O que me espera',

  // ── zprávy ────────────────────────────────────────────────────────────────
  'zpr.titulek': 'Mensagens',
  'zpr.hledatUzivatele': 'Buscar uma pessoa…',
  'zpr.zadneKonverzace': 'Ainda não há conversas',
  'zpr.vyhledejteVyse': 'Busque uma pessoa acima',
  'zpr.vyberteKonverzaci': 'Escolha uma conversa ou busque alguém',
  'zpr.napisteZpravu': 'Escreva uma mensagem…',
  'zpr.nahravam': 'Gravando…',
  'zpr.prilozitObrazek': 'Anexar uma imagem',
  'zpr.hlasovaZprava': 'Mensagem de voz',
  'zpr.zastavitNahravani': 'Parar a gravação',
  'zpr.obrazek': 'Imagem',
  'zpr.overteEmail': 'Para enviar mensagens, confirme seu e-mail.',
  'zpr.profil': 'Perfil',

  // šifrování
  'zpr.sifrovanaZprava': 'Mensagem criptografada',
  'zpr.odemkniNahore': 'Mensagem criptografada — destrave suas mensagens acima.',
  'zpr.nelzeOtevrit': 'Não foi possível abrir esta mensagem criptografada.',

  // hlášky
  'zpr.uzivatelNenalezen': 'Pessoa não encontrada',
  'zpr.prijemceNenalezen': 'Destinatária não encontrada',
  'zpr.prihlasteZnovu': 'Entre de novo (sua sessão expirou)',
  'zpr.serverNedostupny': 'Não dá para alcançar o servidor. Verifique se o backend está rodando.',
  'zpr.chybaOdeslani': 'Não foi possível enviar',
  'zpr.souborVelky': 'O arquivo é grande demais (máx. 5 MB)',
  'zpr.formatNepodporovan': 'Tipo de arquivo não suportado',
  'zpr.mediaOdeslano': 'Arquivo enviado',
  'zpr.mikrofon': 'O microfone não está disponível',
  'zpr.hlasovkaOdeslana': 'Mensagem de voz enviada',
  'zpr.hlasovkaChyba': (p) => `Não foi possível enviar a mensagem de voz: ${p.detail}`,
  'zpr.smazano': 'Conversa apagada',
  'zpr.smazaniChyba': 'Não foi possível apagar a conversa',
  'zpr.smazaniPotvrzeni': 'Ela some da sua lista, com os anexos. A outra pessoa fica com a cópia dela: '
      + 'a mensagem só é apagada do servidor de vez quando as duas apagarem.',

  // ── šifrování zpráv ───────────────────────────────────────────────────────
  'sif.zadejHeslo': 'Digite sua senha.',
  'sif.zapnuto': 'A criptografia está ligada.',
  'sif.odemceno': 'Suas mensagens estão destravadas.',
  'sif.hesloNesedi': 'Essa senha não está certa.',
  'sif.prohlizecNeumi': 'Este navegador não suporta a criptografia que o Bloom usa. Você ainda pode escrever, '
      + 'mas as mensagens não serão criptografadas ponta a ponta.',
  'sif.noveJsouSifrovane': 'As mensagens novas são criptografadas. Só você tem a chave: o servidor não consegue lê-las.',
  'sif.odemkniZpravy': 'Destrave suas mensagens',
  'sif.odemkniPopis': 'A chave vive só na memória desta aba, então depois de recarregar a página a senha é pedida de novo. '
      + 'Não podemos guardá-la em lugar nenhum: aí já não seria uma criptografia que só você controla.',
  'sif.zapniSifrovani': 'Ligar a criptografia das mensagens',
  'sif.zapniPopis': 'As mensagens novas são criptografadas aqui mesmo, no seu aparelho. O servidor recebe só caracteres ilegíveis '
      + 'e não consegue lê-las — nem se um tribunal pedisse.',
  'sif.pozorA': 'Atenção: a chave se abre com a sua senha.',
  'sif.pozorTucne': 'Se você esquecer, ninguém consegue ler suas mensagens criptografadas',
  'sif.pozorB': ' — nós também não. É esse o ponto, mas quer dizer que você precisa de um lugar para guardá-la.',
  'sif.mobilA': 'Ligar também muda como você entra: sua senha deixa de chegar ao servidor, só o hash dela é enviado.',
  'sif.mobilTucne': 'O aplicativo antigo do Bloom não vai mais conseguir entrar nesta conta',
  'sif.mobilB': ' até atualizarmos. Na web tudo continua funcionando.',
  'sif.zapnoutSifrovani': 'Ligar a criptografia',
  'sif.odemknout': 'Destravar',
  'sif.tvojeHeslo': 'Sua senha do Bloom',
  'sif.prilohaZamcena': 'Anexo criptografado — destrave suas mensagens acima.',
  'sif.prilohaChyba': 'Não foi possível abrir o anexo.',
  'sif.priloha': 'Anexo da mensagem',

  // ── v mém okolí ───────────────────────────────────────────────────────────
  'okoli.vaseLokalita': 'Sua localização',
  'okoli.nastavtePolohu': 'Diga onde você está para ver resultados por perto',
  'okoli.vyberteVyse': 'Escolha um lugar acima para ver ofertas e profissionais perto de você',
  'okoli.zadniOdbornici': 'Ainda não há profissionais cadastrados nesta região',
  'okoli.zadneNabidky': 'Ainda não há ofertas nesta região',
  'okoli.zadniClenove': 'Ainda não há ninguém da comunidade nesta região',
  'okoli.vytvoritNabidku': 'Criar uma oferta',

  // ── hledání ───────────────────────────────────────────────────────────────
  'hled.hledam': 'Buscando:',
  'hled.vysledkyPro': 'Resultados da busca:',
  'hled.nicPro': 'Não encontramos nada de:',
  'hled.nicZkuste': 'Não encontramos nada. Tente outra palavra.',
  'hled.zkratte': 'Tente uma frase mais curta ou outra palavra-chave.',
  'hled.zadejte': 'Escreva o que você procura e aperte Enter',
  'hled.priklady': 'Por exemplo: FFS, hormônios, nome, médico, documentos, cirurgia…',
  'hled.uzivatele': 'Pessoas',
  'hled.odbornici': 'Profissionais trans-friendly',
  'hled.clanky': 'Ajuda jurídica – artigos',
  'hled.otazky': 'Perguntas da comunidade',
  'hled.nabidky': 'Ofertas de ajuda',
  'hled.prispevky': 'Publicações',
  'hled.recenze': 'Avaliações de profissionais',

  // ── profil člena ──────────────────────────────────────────────────────────
  'up.nenalezen': 'Pessoa não encontrada',
  'up.oMne': 'Sobre',
  'up.clenOd': 'No Bloom desde',
  'up.odznakSpravce': 'Administração',
  'up.odznakPravnik': 'Advocacia',
  'up.odznakOdbornik': 'Profissional verificado',
  'up.odznakPravnikOvereny': 'Advocacia verificada',
  'up.odznakClen': 'Pessoa verificada',
  'up.odznakPomocnik': 'Ajuda ativa',
  'up.odznakDuveryhodny': 'De confiança',
  // ── zásady komunity ───────────────────────────────────────────────────────
  'kom.zpet': 'Voltar ao Bloom',
  'kom.oProjektu': 'O Bloom nasceu como um espaço comunitário seguro para pessoas trans na Tchéquia — um lugar '
      + 'para compartilhar experiências, encontrar apoio, achar profissionais e conhecer gente. '
      + 'O projeto é tocado pela comunidade, de forma voluntária. Os objetivos são discrição, privacidade e ajuda mútua.',
  'kom.kontaktText': 'Dúvidas ou precisa de ajuda? Escreva. A gente tenta responder o mais rápido possível.',
  'kom.respekt': 'A gente se respeita',
  'kom.respektPopis': 'Chamamos cada pessoa pelo nome e pelos pronomes que ela usa. Respeitamos caminhos e experiências diferentes: '
      + 'não existe jeito certo ou errado de ser trans.',
  'kom.soukromi': 'Cuidamos da privacidade umas das outras',
  'kom.soukromiPopis': 'O que é compartilhado no Bloom fica no Bloom. Não compartilhe informações sobre outras pessoas sem '
      + 'o consentimento delas. Respeitamos o anonimato.',
  'kom.pomahame': 'A gente se ajuda',
  'kom.pomahamePopis': 'O Bloom é sobre apoio mútuo. Compartilhamos experiências, damos uma mão e construímos um espaço seguro '
      + 'para quem procura companhia ou informação.',
  'kom.obtezovani': 'Não toleramos assédio',
  'kom.obtezovaniPopis': 'Assédio, perseguição ou comentários hostis não têm lugar no Bloom. Se algo te incomodar, '
      + 'escreva para a administração.',
  'kom.spam': 'Nada de spam nem publicidade',
  'kom.spamPopis': 'O Bloom não é um mercado. Não publique publicidade não pedida nem conteúdo comercial. '
      + 'Ofertas e pedidos vão em Apoio mútuo.',
  'kom.prostor': 'Um espaço para cada etapa',
  'kom.prostorPopis': 'Você não está sozinha, em qualquer ponto do caminho em que esteja. Damos as boas-vindas a quem está pensando '
      + 'na transição, a quem está no meio dela e a quem já passou — e tomamos cada caminho como ele é.',
  'kom.dataPopis': 'O Bloom coleta só os dados de que a plataforma precisa para funcionar: seu e-mail, seu apelido e o perfil '
      + 'que você mesma cria.',
  'kom.dataTretiStrany': 'Seus dados não são compartilhados com terceiros. A plataforma não usa tecnologia de rastreamento nem redes de publicidade.',
  'kom.dataSmazani': 'Você tem o direito de pedir que sua conta e todos os dados ligados a ela sejam apagados. Escreva para a administração.',

  'okoli.podtitulek': 'Encontre pessoas da comunidade, serviços e profissionais perto de você',
  'okoli.cleneVOkoli': (p) => `Pessoas da comunidade perto de ${p.misto}`,
  'okoli.nabidkyVOkoli': (p) => `Ofertas de ajuda perto de ${p.misto}`,
  'okoli.odborniciVOkoli': (p) => `Profissionais perto de ${p.misto}`,
  'hled.zobrazitVice': 'Ver mais',
  'kom.titulek': 'Regras da comunidade',
  'kom.podtitulek': 'Um espaço seguro para todo mundo',
  'kom.jakNahlasit': 'Como relatar um problema',
  'kom.jakNahlasitPopis': 'Se você encontrar um comportamento inadequado, tem duas opções: usar o botão «Denunciar esta pessoa» '
      + 'no perfil dela, ou escrever para a administração.',
  'kom.duverne': 'Sua denúncia é confidencial.',
  'kom.ochranaSoukromi': 'Privacidade',
  'obecne.zpetKratce': 'Voltar',

  // ── průvodce fází ─────────────────────────────────────────────────────────
  'cesta.nikdoNesdili': 'Ainda ninguém mais da comunidade compartilha esta etapa publicamente.',
  'cesta.poznamkaFazePriklad': 'O que você quiser compartilhar ou lembrar desta etapa…',
  'pruvodce.fazeNenalezena': 'Etapa não encontrada',
  'pruvodce.pripravujeme': 'Ainda estamos preparando esta parte.',
  'pruvodce.krokyJenTy': 'Os passos que você marca só você vê.',
  'pruvodce.nastavitFazi': 'Definir como a minha etapa atual',
  'pruvodce.fazeNastavena': 'Definida como a sua etapa atual',
  'pruvodce.chyba': 'Não foi possível salvar, tente de novo',
  'pruvodce.kroku': 'passos',
  'pruvodce.odborniku': (p) => `${p.pocet === 1 ? 'profissional' : 'profissionais'} para esta etapa`,
  'pruvodce.pribehu': (p) => `${p.pocet === 1 ? 'relato' : 'relatos'} de pessoas nesta etapa`,

  // ── obnovení hesla ────────────────────────────────────────────────────────
  'reset.titulek': 'Redefinir a senha',
  'reset.popis': 'Digite uma nova senha para a sua conta do Bloom.',
  'reset.noveHeslo': 'Nova senha',
  'reset.noveHesloPriklad': 'Digite uma nova senha',
  'reset.potvrdit': 'Confirme a nova senha',
  'reset.nastavit': 'Salvar a nova senha',
  'reset.ukladam': 'Salvando…',
  'reset.hotovo': 'Sua senha foi trocada. Você já pode entrar.',
  'reset.neplatnyOdkaz': 'Esse link para redefinir a senha não é válido.',
  'reset.odkazVyprsel': 'O link expirou ou não é válido. Peça um novo.',
  'reset.chyba': 'Não foi possível redefinir a senha.',
  'reset.neshoda': 'As senhas não são iguais.',
  'reset.ztratiPristup': 'vai perder o acesso',

  'cesta.volitelne': 'Isto é totalmente opcional. Compartilhe sua etapa de transição se quiser — ou guarde só para você. '
      + 'Também dá para achar gente num ponto parecido do caminho.',
  'cesta.hledatVeFazi': 'Achar pessoas nesta etapa:',
  'cesta.jenVerejne': '(só quem compartilha publicamente)',
  'pruvodce.zpetNaCestu': 'Voltar para Meu caminho',
  'pruvodce.tadyJsi': 'Você está aqui',
  'reset.prejitNaPrihlaseni': 'Ir para o login',
  'reset.sifrovaniVarovani': 'Se você tem a criptografia das mensagens ligada: redefinir a senha significa que não vai mais alcançar '
      + 'suas mensagens criptografadas antigas. A chave delas se abre com a senha original, e ninguém aqui a conhece, então '
      + 'não dá para reembrulhar. As mensagens novas ainda poderão ser criptografadas; as antigas não serão lidas — nem por nós.',

  // ── veřejná úvodní stránka ────────────────────────────────────────────────
  'uvod.prihlasit': 'Entrar',
  'uvod.vytvoritUcet': 'Criar uma conta',
  'uvod.uzMamUcet': 'Já tenho conta',
  'uvod.nadpis': 'Um espaço seguro para a comunidade trans',
  'uvod.podnadpis': 'O Bloom é um lugar privado onde você pode falar abertamente, encontrar profissionais trans-friendly '
      + 'e viver sua transição entre gente que sabe como é.',
  'uvod.zdarma': 'Criar conta é de graça. O conteúdo do Bloom só abre depois do login.',
  'uvod.kCemuJe': 'Para que serve o Bloom',
  'uvod.kCemuJe1': 'Procurar informação sobre transição na Tchéquia costuma ser clicar por fóruns '
      + 'espalhados, artigos desatualizados e links em que não dá para saber se confia. E muitas perguntas '
      + 'quem responde melhor é alguém que já passou por isso.',
  'uvod.kCemuJe2': 'O Bloom junta tudo num lugar só: profissionais com quem a comunidade tem boa experiência, um guia '
      + 'pelas etapas da transição, ajuda jurídica e, acima de tudo, gente para quem escrever.',
  'uvod.kCemuJe3': 'E porque são coisas que ninguém quer contar para a internet inteira, o Bloom foi feito desde '
      + 'o começo para que de fora não se veja absolutamente nada.',
  'uvod.coNajdes': 'O que você vai encontrar no Bloom',
  'uvod.coNajdesPopis': 'Oito partes que se apoiam umas nas outras — da ajuda prática às experiências compartilhadas.',
  'uvod.soukromiZaklad': 'Privacidade não é um extra, é a base',
  'uvod.jakZabezpeceny': 'Como o Bloom é protegido',
  'uvod.zabezpeceniPopis': 'Os dados das pessoas não são vendidos nem analisados. No Bloom não roda nenhum rastreamento '
      + 'de publicidade nem de análise — nenhum script de terceiros descobre nada sobre você.',
  'uvod.coNeumi': 'O que o Bloom não consegue fazer',
  'uvod.metadataTucne': 'quem escreveu para quem e quando',
  'uvod.coNeumiA': 'O servidor sempre sabe',
  'uvod.coNeumiB': ' — sem isso não conseguiria entregar a mensagem. A criptografia ponta a ponta não esconde esses '
      + 'metadados, e o Signal também não. Os perfis não dá para criptografar, porque o servidor precisa mostrá-los '
      + 'para as outras pessoas. E como o Bloom é um aplicativo web, ele baixa o código de criptografia do nosso servidor '
      + 'toda vez que você abre — quem dominasse o servidor poderia, em tese, servir um alterado. '
      + 'Contra isso só protege um aplicativo assinado de uma loja.',
  'uvod.pridejSe': 'Venha com a gente',
  'uvod.pridejSePopis': 'Basta um apelido e um e-mail — você não precisa dar seu nome de registro em lugar nenhum. O que escrever '
      + 'sobre você depende de você, e dá para mudar ou apagar quando quiser.',

  // co Bloom nabízí
  'uvod.karta.podpora': 'Ofereça ajuda ou peça: de acompanhar alguém numa consulta a emprestar roupa ou um '
      + '«preciso falar com alguém».',
  'uvod.karta.odbornici': 'Sexologia, endocrinologia, cirurgia, psicoterapia e até cabeleireiro. Com mapa, contatos e as experiências das outras pessoas.',
  'uvod.karta.pravo': 'Mudança de nome, documentos, trabalho, escola. Respondem pessoas que conhecem o terreno.',
  'uvod.karta.pruvodce': 'O que te espera em cada passo — das primeiras perguntas às cirurgias. Com links para fontes verificadas e profissionais.',
  'uvod.karta.zpravy': 'Escreva para qualquer pessoa da comunidade. As mensagens e os anexos ficam criptografados no servidor.',
  'uvod.karta.zkusenosti': 'Histórias reais de quem passou por isso. Sem censura e sem enfeitar.',
  'uvod.karta.aktuality': 'O que acontece em torno dos temas trans na Tchéquia — mudanças de lei, eventos, novidades da comunidade.',
  'uvod.karta.okoli': 'Quem está perto de você. Para você saber que não está sozinha, nem numa cidade pequena.',

  // zabezpečení
  'uvod.bezp.zvencinic': 'De fora não se vê absolutamente nada',
  'uvod.bezp.zvencinicText': 'Perfis, relatos, fotos, ofertas e imagens das publicações exigem login. Sem conta, o '
      + 'servidor não entrega nenhum dado sobre as pessoas — nem para os buscadores.',
  'uvod.bezp.hesla': 'Ninguém sabe sua senha',
  'uvod.bezp.heslaText': 'Só se guarda um hash bcrypt, do qual não dá para calcular a senha original. Nem a '
      + 'administração vê sua senha ou consegue mandá-la — só pode deixar você definir uma nova.',
  'uvod.bezp.sifrovani': 'Mensagens criptografadas de você para a outra pessoa',
  'uvod.bezp.sifrovaniText': 'Quando você liga a criptografia ponta a ponta, o texto e os anexos são criptografados no seu próprio navegador. '
      + 'A chave se abre com a sua senha e nunca sai do seu aparelho — o servidor recebe só '
      + 'caracteres ilegíveis e não consegue ler, nem se um tribunal pedisse. Sem criptografia, as mensagens estão ao menos '
      + 'criptografadas no disco do servidor.',
  'uvod.bezp.kontakty': 'Seus contatos continuam seus',
  'uvod.bezp.kontaktyText': 'Seu e-mail e seu telefone nunca são devolvidos a outras pessoas. Sua etapa de transição é privada até '
      + 'você mesma publicá-la — e os passos que marca no Guia só você vê.',
  'uvod.bezp.smazane': 'Apagado é apagado de verdade',
  'uvod.bezp.smazaneText': 'Você pode apagar uma conversa quando quiser. Quando as duas partes apagam, ela some do servidor '
      + 'para sempre, com os anexos.',
  'uvod.bezp.server': 'Servidor próprio na Europa',
  'uvod.bezp.serverText': 'O Bloom roda num servidor próprio na União Europeia, só por HTTPS. O banco de dados não é alcançável '
      + 'pela internet. Os backups saem criptografados para outro armazenamento e a restauração deles foi testada.',

  'uvod.karta.pruvodceNazev': 'Guia pela transição',
  'uvod.karta.zpravyNazev': 'Mensagens privadas',
  // ── vzájemná podpora ──────────────────────────────────────────────────────
  'pod.podtitulek': 'Ofereça o que você sabe fazer e receba ajuda de outras pessoas da comunidade',
  'pod.vse': 'Tudo',
  'pod.nabidky': 'Ofertas',
  'pod.poptavky': 'Pedidos',
  'pod.nabidka': 'Oferta',
  'pod.poptavka': 'Pedido',
  'pod.celaCR': 'Tchéquia inteira',
  'pod.celySvet': 'O mundo inteiro',
  'pod.cesko': 'Tchéquia',
  'pod.svet': 'Mundo',
  'pod.vsechnyTypy': 'Todas as categorias',
  'pod.moje': (p) => `Minhas (${p.pocet})`,
  'pod.pridat': 'Adicionar',
  'pod.overEmail': 'Confirme seu e-mail para poder adicionar uma oferta',
  'pod.novaPoptavka': 'Novo pedido',
  'pod.novaNabidka': 'Nova oferta',
  'pod.popisPoptavky': 'Escreva o que você procura e o que oferece em troca.',
  'pod.popisNabidky': 'Ofereça o que você sabe fazer para outras pessoas da comunidade.',
  'pod.typPrispevku': 'Tipo de publicação',
  'pod.volitelne': '(opcional)',
  'pod.coNabizim': 'O que eu ofereço',
  'pod.coNabizimP': 'O que eu ofereço *',
  'pod.coHledamP': 'O que eu procuro *',
  'pod.coHledamVymenou': 'O que eu procuro em troca',
  'pod.priklOffer': 'p. ex. cozinhar, cabelo, tradução…',
  'pod.priklNeed': 'p. ex. massagem, fotografia…',
  'pod.poptavkaSeZobrazi': 'Seu pedido vai aparecer na aba Pedidos.',
  'pod.nabidkaSeZobrazi': 'Se você preencher, sua oferta também vai aparecer na aba Pedidos.',
  'pod.popis': 'Descrição',
  'pod.popisPriklad': 'Uma descrição mais detalhada…',
  'pod.oblast': 'Região',
  'pod.lokalita': 'Local',
  'pod.nechciUvadet': 'Prefiro não dizer',
  'pod.kategorie': 'Categoria',
  'pod.ostatni': 'Outros',
  'pod.pridatPoptavku': 'Adicionar o pedido',
  'pod.pridatNabidku': 'Adicionar a oferta',
  'pod.odpovedetNaPrispevek': 'Responder à publicação',
  'pod.napisteAutorovi': 'Escreva uma mensagem privada para quem publicou.',
  'pod.od': (p) => `De: ${p.kdo}`,
  'pod.odeslatZpravu': 'Enviar a mensagem',
  'pod.konceptOdpovedi': (p) => `Oi! Fiquei interessada no seu ${p.co} «${p.nazev}». `,
  'pod.konceptPoptavka': 'pedido',
  'pod.konceptNabidka': 'oferta',
  'pod.zadneMoje': 'Você ainda não tem publicações',
  'pod.zadneNalezeny': 'Nenhuma publicação encontrada',
  'pod.vytvortePrvni': 'Crie sua primeira oferta ou pedido',
  'pod.zkusteFiltry': 'Tente mudar os filtros ou adicione uma publicação nova',
  'pod.expirovano': 'Expirada',
  'pod.hledam': 'Procuro',
  'pod.hledamCo': (p) => `Procuro: ${p.co}`,
  'pod.nabizimCo': (p) => `Ofereço: ${p.co}`,
  'pod.expirovala': 'Esta oferta expirou. Escreva para a administração para renovar.',
  'pod.odpovedet': 'Responder',
  'pod.upravitPrispevek': 'Editar a publicação',
  'pod.upravtePrispevek': 'Edite sua oferta ou seu pedido.',
  'pod.nabizimP': 'Ofereço *',
  'pod.hledamPotrebuji': 'Procuro / preciso de',
  'pod.coNabizitePriklad': 'O que você oferece…',
  'pod.coHledatePriklad': 'O que você procura…',
  'pod.ulozitZmeny': 'Salvar as mudanças',
  'pod.vytvorenoPoptavka': 'Pedido criado.',
  'pod.vytvorenoNabidka': 'Oferta criada.',
  'pod.chybaVytvorit': 'Não foi possível criar a publicação',
  'pod.opravduSmazat': 'Apagar esta oferta?',
  'pod.smazano': 'Apagado',
  'pod.chybaSmazat': 'Não foi possível apagar',
  'pod.aktualizovano': 'Publicação atualizada.',
  'pod.chybaUlozit': 'Não foi possível salvar',
  'pod.zpravaOdeslana': 'Mensagem enviada.',
  'pod.chybaOdeslat': 'Não foi possível enviar a mensagem',
  'obecne.hledatPriklad': 'Buscar…',
  'obecne.upravit': 'Editar',

  // ── odborníci ─────────────────────────────────────────────────────────────
  'odb.podtitulek': 'Encontre profissionais verificados que podem te ajudar no caminho',
  'odb.hledatPriklad': 'Buscar por nome ou cidade…',
  'odb.vsechnyObory': 'Todas as áreas',
  'odb.radit': 'Ordenar:',
  'odb.vychozi': 'Padrão',
  'odb.nejvyssiHodnoceni': '★ Mais bem avaliados',
  'odb.nejnizsiHodnoceni': '★ Pior avaliados',
  'odb.zadniNalezeni': 'Nenhum profissional encontrado',
  'odb.zkusteFiltry': 'Tente mudar os filtros',
  'odb.recenzi': (p) => (p.pocet === 1 ? 'avaliação' : 'avaliações'),
  'odb.dostupnyV': 'Disponível em:',
  'odb.otevritVMapach': 'Abrir no mapa',
  'odb.pridatRecenzi': 'Adicionar uma avaliação',
  'odb.ohodnotte': 'Avalie sua experiência com esta pessoa.',
  'odb.vaseHodnoceni': 'Sua nota *',
  'odb.popisZkusenosti': 'Descreva sua experiência',
  'odb.popisteZkusenost': 'Descreva sua experiência…',
  'odb.odeslatRecenzi': 'Enviar a avaliação',
  'odb.recenze': (p) => `Avaliações (${p.pocet})`,
  'odb.zadneRecenze': 'Ainda não há avaliações. Seja a primeira pessoa.',
  'odb.vyberteOdbornika': 'Escolha um profissional para ver os dados e o mapa',
  'odb.pridatOdbornika': 'Adicionar profissional',
  'odb.pridejteOdbornika': 'Adicione à lista um novo profissional verificado.',
  'odb.navrhnout': 'Sugerir profissional',
  'odb.navrhnetePopis': 'Sugira um profissional para a administração aprovar.',
  'odb.navrhVysvetleni': 'Sua sugestão vai para a administração. Depois de aprovada, aparece na lista.',
  'odb.overEmail': 'Confirme seu e-mail para sugerir um profissional',
  'odb.jmeno': 'Nome *',
  'odb.kategorie': 'Categoria *',
  'odb.popis': 'Descrição',
  'odb.popisPriklad': 'Especialidade, experiência…',
  'odb.adresa': 'Endereço *',
  'odb.mesto': 'Cidade *',
  'odb.kraj': 'Região',
  'odb.vyber': 'Escolha',
  'odb.stat': 'País',
  'odb.cesko': 'Tchéquia',
  'odb.telefon': 'Telefone',
  'odb.web': 'Site',
  'odb.odesilam': 'Enviando…',
  'odb.odeslatKeSchvaleni': 'Enviar para aprovação',
  'odb.recenzePridana': 'Avaliação adicionada.',
  'odb.chybaRecenze': 'Não foi possível adicionar a avaliação',
  'odb.odeslanKeSchvaleni': 'A sugestão foi enviada para aprovação.',
  'odb.chybaOdeslat': 'Não foi possível enviar',
  'odb.pridan': 'Profissional adicionado.',
  'odb.chybaPridat': 'Não foi possível adicionar',
  'odb.polozitOtazku': 'Fazer uma pergunta',
  'odb.novaOtazka': 'Nova pergunta para profissionais',
  'odb.naCoSeZeptat': 'O que você quer perguntar aos profissionais?',

  // ── právní poradna ────────────────────────────────────────────────────────
  'prav.podtitulek': 'Informação e apoio para a comunidade trans',
  'prav.zpetNaPoradnu': 'Voltar para Ajuda jurídica',
  'prav.clankyAPruvodci': 'Artigos e guias',
  'prav.pridatClanek': 'Adicionar um artigo',
  'prav.novyClanek': 'Novo artigo',
  'prav.vytvorteClanek': 'Escreva um artigo novo para a parte jurídica.',
  'prav.nazev': 'Título *',
  'prav.kategorie': 'Categoria',
  'prav.publikovatIhned': 'Publicar já',
  'prav.publikovano': 'Publicado',
  'prav.obsah': 'Conteúdo *',
  'prav.obsahPriklad': 'Conteúdo do artigo…',
  'prav.zadneClanky': 'Não há artigos nesta categoria',
  'prav.skryto': 'Oculto',
  'prav.skryt': 'Ocultar',
  'prav.publikovat': 'Publicar',
  'prav.upravitClanek': 'Editar o artigo',
  'prav.upravteObsah': 'Edite o conteúdo deste artigo.',
  'prav.clanekPridan': 'Artigo adicionado.',
  'prav.chybaPridat': 'Não foi possível adicionar o artigo',
  'prav.clanekUpraven': 'Artigo atualizado.',
  'prav.opravduSmazat': 'Apagar este artigo?',
  'prav.chybaStav': 'Não foi possível mudar a situação',
  'prav.pridatOtazku': 'Adicionar uma pergunta',
  'prav.novaOtazka': 'Nova pergunta',
  'prav.naCoSeZeptat': 'O que você quer perguntar?',
  'obecne.vse': 'Tudo',

  // ── aktuality ─────────────────────────────────────────────────────────────
  'akt.podtitulek': 'Novidades do mundo trans',
  'akt.prehratVideo': 'Reproduzir o vídeo',
  'akt.obrazekVClanku': 'Imagem do artigo',
  'akt.clanekNenalezen': 'Artigo não encontrado',
  'akt.zpetNaAktuality': 'Voltar para as notícias',
  'akt.autor': (p) => `Autoria: ${p.kdo}`,
  'akt.osobniPribeh': 'Relato pessoal',
  'akt.upravitClanek': 'Editar o artigo',
  'akt.komentare': (p) => `Comentários (${p.pocet})`,
  'akt.zadneKomentare': 'Ainda não há comentários. Seja a primeira pessoa.',
  'akt.pridatKomentar': 'Adicionar um comentário…',
  'akt.proKomentovaniOverte': 'Confirme seu e-mail para comentar.',
  'akt.profil': 'Perfil',
  'akt.prihlasteSeProKomentovani': 'Entre para comentar.',
  'akt.upravteObsah': 'Edite o conteúdo deste artigo.',
  'akt.nadpisP': 'Título *',
  'akt.nadpis': 'Título',
  'akt.obsahP': 'Conteúdo *',
  'akt.textClanku': 'Texto do artigo…',
  'akt.obrazekUrlNeboSoubor': 'Imagem (endereço ou arquivo)',
  'akt.videoUrlNeboSoubor': 'Vídeo (endereço ou arquivo)',
  'akt.ukladam': 'Salvando…',
  'akt.novaAktualita': 'Nova notícia',
  'akt.sdiletPribeh': 'Compartilhar um relato',
  'akt.vytvoritAktualitu': 'Escrever uma notícia',
  'akt.sdiletZkusenost': 'Compartilhar uma experiência',
  'akt.napisteAktualitu': 'Escreva uma notícia nova para a comunidade.',
  'akt.podelteSe': 'Compartilhe sua experiência com a comunidade.',
  'akt.obrazek': 'Imagem',
  'akt.nahratObrazek': 'Enviar uma imagem…',
  'akt.nahratVideo': 'Enviar um vídeo…',
  'akt.neboUrl': 'ou um endereço:',
  'akt.textAktuality': 'Texto da notícia…',
  'akt.sdilejtePribeh': 'Compartilhe sua história ou sua experiência com a comunidade…',
  'akt.nahravam': 'Enviando…',
  'akt.publikovat': 'Publicar',
  'akt.zkusenostiTucne': 'Experiências pessoais da comunidade.',
  'akt.zkusenostiPopis': 'Esta parte serve para compartilhar experiências e histórias de vida. As publicações podem ter texto, imagens ou vídeo.',
  'akt.sdiletSvujPribeh': 'Compartilhar meu relato',
  'akt.zadneAktuality': 'Não há notícias',
  'akt.zadneVKategorii': 'Ainda não há nada nesta categoria',
  'akt.publikovan': 'Publicação publicada.',
  'akt.chybaPublikovat': 'Não foi possível publicar',
  'akt.opravduSmazat': 'Apagar esta publicação?',
  'akt.chyba': 'Alguma coisa deu errado',
  'akt.chybaKomentar': 'Não foi possível adicionar o comentário',
  'akt.chybaSmazatKomentar': 'Não foi possível apagar o comentário',
  'akt.aktualizovan': 'Publicação atualizada.',
  'obecne.smazat': 'Apagar',

  // ── fáze tranzice ─────────────────────────────────────────────────────────
  'faze.thinking': 'Estou pensando na transição',
  'faze.thinking.popis': 'Estou descobrindo quem eu sou e qual caminho é o meu.',
  'faze.research': 'Estou procurando informação',
  'faze.research.popis': 'Leio, pergunto, procuro fontes e comunidade.',
  'faze.therapist': 'Primeira consulta com terapeuta',
  'faze.therapist.popis': 'Falo do meu caminho com uma pessoa profissional.',
  'faze.hormones': 'Terapia hormonal',
  'faze.hormones.popis': 'Estou começando ou seguindo com a terapia hormonal.',
  'faze.documents': 'Mudança de documentos',
  'faze.documents.popis': 'Estou tratando da mudança legal de nome ou de sexo.',
  'faze.cosmetic': 'Aparência e cuidados',
  'faze.cosmetic.popis': 'Trabalho na minha aparência: cabelo, maquiagem, estilo.',
  'faze.surgery-thinking': 'Estou pensando em cirurgias',
  'faze.surgery-thinking.popis': 'Estou avaliando as opções cirúrgicas.',
  'faze.surgery': 'Depois das cirurgias',
  'faze.surgery.popis': 'Já fiz uma ou mais cirurgias.',
  'faze.stable': 'Etapa estável',
  'faze.stable.popis': 'Estou onde quero estar e vivo a minha vida.',
  'faze.individual': 'Meu próprio caminho',
  'faze.individual.popis': 'Meu caminho não cabe em nenhuma caixinha — e tudo bem.',

  // ── zkušenosti komunity ───────────────────────────────────────────────────
  'zk.podtitulek': 'Aqui é onde se compartilham os relatos.',
  'zk.pribehNenalezen': 'Relato não encontrado',
  'zk.zpetNaPribehy': 'Voltar para os relatos',
  'zk.komunita': 'A comunidade',
  'zk.pribeh': 'Relato',
  'zk.upravitPribeh': 'Editar o relato',
  'zk.upravtePribeh': 'Edite o relato que você compartilhou.',
  'zk.textPribehu': 'Texto do relato…',
  'zk.fazeTranzice': 'Etapa da transição',
  'zk.neuvadet': 'Não dizer',
  'zk.ukazeSeLidem': 'O relato vai aparecer para quem lê o guia daquela etapa.',
  'zk.sdiletPribeh': 'Compartilhar um relato',
  'zk.overEmail': 'Confirme seu e-mail para compartilhar um relato',
  'zk.zadnePribehy': 'Ainda não há relatos. Seja a primeira pessoa.',
  'zk.nazevPribehu': 'O título do seu relato…',
  'zk.pribehP': 'Relato *',
  'zk.sdilejteZkusenost': 'Compartilhe sua experiência com a comunidade…',
  'zk.chybaNacist': 'Não foi possível carregar os relatos',
  'zk.vyplnteNadpis': 'Preencha o título e o texto',
  'zk.spatnyOdkaz': 'O link da imagem precisa começar com http://, https:// ou /',
  'zk.sdilen': 'Relato compartilhado.',
  'zk.chybaSdilet': 'Não foi possível compartilhar',
  'zk.opravduSmazat': 'Apagar este relato?',
  'zk.smazan': 'Relato apagado',
  'zk.aktualizovan': 'Relato atualizado.',

  // ── rám aplikace ──────────────────────────────────────────────────────────
  'ram.emailNeoveren': 'Seu e-mail ainda não foi confirmado. Confirme, por favor.',
  'ram.odesilam': 'Enviando…',
  'ram.znovuOdeslat': 'Enviar de novo',
  'ram.chceteUpozorneni': 'Quer receber avisos de mensagens novas?',
  'ram.tedNe': 'Agora não',
  'ram.paticka': '© 2026 Bloom – um espaço privado para a comunidade trans',
  'ram.zasadyKomunity': 'Regras da comunidade',
  'ram.prekladNeovereny': 'Ninguém que fale este idioma revisou esta tradução ainda. Se algo soar errado, avise.',
  'ram.nahlasitProblem': 'Relatar um problema',

  // ── otázky komunity ───────────────────────────────────────────────────────
  'ot.spravce': 'Administração',
  'ot.overenyPravnik': 'Advocacia verificada',
  'ot.overenyOdbornik': 'Profissional verificado',
  'ot.odznakJinaZeme': (p) => `Este selo vale apenas para: ${p.zeme}`,
  'ot.otazkyKomunity': 'Perguntas da comunidade',
  'ot.pridatOtazku': 'Adicionar uma pergunta',
  'ot.novaOtazka': 'Nova pergunta',
  'ot.naCoSeZeptat': 'O que você quer perguntar?',
  'ot.otazkaSeZobrazi': 'Sua pergunta vai aparecer para outras pessoas da comunidade, que podem responder.',
  'ot.otazkaP': 'Pergunta *',
  'ot.oblastTema': 'Área / tema',
  'ot.vseObecna': 'Qualquer coisa (pergunta geral)',
  'ot.odeslatOtazku': 'Enviar a pergunta',
  'ot.overEmail': 'Confirme seu e-mail para poder perguntar',
  'ot.zadneOtazky': 'Ainda não há perguntas. Seja a primeira pessoa.',
  'ot.hlasu': (p) => (p.pocet === 1 ? 'voto' : 'votos'),
  'ot.odpovedi': (p) => (p.pocet === 1 ? 'resposta' : 'respostas'),
  'ot.zadneOdpovedi': 'Ainda não há respostas.',
  'ot.napisteOdpoved': 'Escreva uma resposta…',
  'ot.jenPravnici': 'As perguntas de Ajuda jurídica são respondidas por advocacia verificada e pela administração.',
  'ot.smazatOtazku': 'Apagar esta pergunta?',

  // ── cizí profil: nabídky, galerie, nahlášení ──────────────────────────────
  'cp.nabidkyAPoptavky': 'Ofertas e pedidos',
  'cp.zadneNabidky': 'Sem ofertas',
  'cp.napsatZpravu': 'Escrever uma mensagem',
  'cp.nahlasitUzivatele': 'Denunciar esta pessoa',
  'cp.nahlasitKoho': (p) => `Denunciar ${p.kdo}`,
  'cp.popisteDuvod': 'Conte por que você está denunciando. A administração vai ver a denúncia.',
  'cp.zustaneteAnonymni': 'A denúncia vai para a administração. Você continua anônima.',
  'cp.duvodP': 'Motivo *',
  'cp.vybertDuvod': 'Escolha um motivo…',
  'cp.nevhodneChovani': 'Comportamento inadequado',
  'cp.falesnyProfil': 'Perfil falso',
  'cp.jinyProblem': 'Outro problema',
  'cp.popisVolitelny': 'Descrição',
  'cp.volitelny': '(opcional)',
  'cp.popisteSituaci': 'Conte a situação com mais detalhes…',
  'cp.odeslatNahlaseni': 'Enviar a denúncia',
  'cp.vyberteDuvodChyba': 'Escolha um motivo para a denúncia',
  'cp.nahlaseniOdeslano': 'A denúncia foi enviada para a administração',
  'cp.chybaNahlaseni': 'Não foi possível enviar a denúncia',
  'gal.chranenoHeslem': 'Protegida por senha',
  'gal.soukromi': 'Privacidade',
  'gal.nahravam': 'Enviando…',
  'gal.pridatFotku': 'Adicionar uma foto',
  'gal.nastaveniSoukromi': 'Privacidade da galeria',
  'gal.verejna': 'Pública',
  'gal.chranenaHeslem': 'Protegida por senha',
  'gal.nastaveniUlozeno': 'Ajustes da galeria salvos',
  'gal.jeChranena': 'Esta galeria é protegida por senha',
  'gal.zadneFotky': 'Ainda não há fotos. Adicione a primeira.',
  'gal.otagovat': 'Marcar alguém',
  'gal.hledatUzivatele': 'Buscar uma pessoa…',
  'gal.odemcena': 'Galeria destravada',
  'gal.spatneHeslo': 'Senha da galeria incorreta',
  'gal.fotkaNahrana': 'Foto enviada.',
  'gal.chybaNahrat': 'Não foi possível enviar a foto',
  'gal.fotkaSmazana': 'Foto apagada',
  'gal.jizOtagovan': 'Essa pessoa já está marcada',
  'gal.otagovan': (p) => `Marcada: ${p.kdo}`,
  'gal.chybaTag': 'Não foi possível adicionar a marcação',
  'gal.soukromiGalerie': 'Privacidade da galeria',
  'gal.verejnaGalerie': 'Galeria pública',

  'ram.povolit': 'Permitir',
  'ram.oProjektu': 'O projeto',
  'ram.kontakt': 'Contato',

  // ── mapa světa a počty obsahu ─────────────────────────────────────────────
  'mapa.popis': 'Mapa do mundo – clique num país para abri-lo',
  'mapa.priblizit': 'Aproximar',
  'mapa.oddalit': 'Afastar',
  'mapa.celySvet': 'Voltar ao mundo inteiro',
  'mapa.chybaNacteni': 'Não foi possível carregar o mapa',
  'mapa.chybaZkusteSeznam': 'Não foi possível carregar o mapa. Tente a lista de países abaixo.',
  'mapa.teprveRoste': 'O Bloom está só começando aqui',
  'mapa.napovedaDotyk': 'Arraste para mover o mapa; use dois dedos, toque duas vezes ou os botões para aproximar. Você não precisa usá-lo — a busca e a lista completa de países estão abaixo.',
  'obsah.specialists': (p) => (p.pocet === 1 ? 'profissional' : 'profissionais'),
  'obsah.organizations': (p) => (p.pocet === 1 ? 'organização' : 'organizações'),
  'obsah.events': (p) => (p.pocet === 1 ? 'evento' : 'eventos'),
  'obsah.pageants': (p) => (p.pocet === 1 ? 'concurso' : 'concursos'),
  'obsah.resources': (p) => (p.pocet === 1 ? 'recurso' : 'recursos'),
  'obsah.zaznamu': (p) => `${p.pocet} ${p.pocet === 1 ? 'registro' : 'registros'}`,

  // ── výběr domovské země ───────────────────────────────────────────────────
  'domov.otazka': 'Onde fica a sua casa?',
  'domov.popis': 'Com isso o Bloom vai te mostrar o que está perto. Você pode olhar qualquer país — isso não muda '
      + 'o seu país de residência. Não é publicado em lugar nenhum e dá para mudar quando quiser.',
  'domov.preskocit': 'Pular',
  'domov.najitZemi': 'Achar um país…',
  'domov.nicNeodpovida': 'Nada corresponde. Tente outra busca.',
  'domov.klikniDoMapy': 'Você também pode simplesmente clicar num país no mapa acima.',

  // ── vyhledávání v liště ───────────────────────────────────────────────────
  'typ.posts': 'Publicação',
  'typ.users': 'Pessoa',
  'typ.specialists': 'Profissional',
  'typ.services': 'Oferta',
  'typ.articles': 'Ajuda jurídica',
  'typ.questions': 'Pergunta da comunidade',
  'typ.reviews': 'Avaliação de um profissional',
  'nav.emailNeoveren': 'E-mail não confirmado',
  'nav.neovereny': 'Não confirmado',

  // ── hlášení problému ──────────────────────────────────────────────────────
  'chyba.neco': 'Alguma coisa não funciona',
  'chyba.navrh': 'Uma ideia de melhoria',
  'chyba.bezpecnost': 'Um problema de segurança',
  'chyba.jiny': 'Outra coisa',
  'chyba.vyberteTyp': 'Escolha o tipo de problema',
  'chyba.popisteProsim': 'Descreva o problema',
  'chyba.odeslano': 'Relato enviado, obrigada!',
  'chyba.chybaOdeslat': 'Não foi possível enviar o relato',
  'chyba.napisteNam': 'Conte o que aconteceu — ajuda a gente a consertar.',
  'chyba.typProblemu': 'Tipo de problema',
  'chyba.popisProblemu': 'O que aconteceu',
  'chyba.popisPriklad': 'Conte o que aconteceu, o que você esperava e o que aconteceu no lugar…',
  'chyba.priloha': 'Anexamos automaticamente: a página atual, a hora e informações sobre o seu navegador.',
  'chyba.odeslatHlaseni': 'Enviar o relato',

  // ── editor textu ──────────────────────────────────────────────────────────
  'ed.napisteObsah': 'Escreva o conteúdo…',
  'ed.tucne': 'Negrito (Ctrl+B)',
  'ed.kurziva': 'Itálico (Ctrl+I)',
  'ed.odrazky': 'Lista com marcadores',
  'ed.vlozitOdkaz': 'Inserir um link',
  'ed.vlozitTabulku': 'Inserir uma tabela',
  'ed.radky': 'Linhas',
  'ed.sloupce': 'Colunas',
  'ed.vlozit': 'Inserir',
  'ed.barva.cerna': 'Preto',
  'ed.barva.seda': 'Cinza',
  'ed.barva.fialova': 'Roxo',
  'ed.barva.ruzova': 'Rosa',
  'ed.barva.modra': 'Azul',
  'ed.barva.zelena': 'Verde',
  'ed.barva.cervena': 'Vermelho',
  'ed.barva.oranzova': 'Laranja',

  // ── ověření e-mailu a přihlášení přes jiné služby ─────────────────────────
  'over.neplatnyOdkaz': 'Esse link de confirmação não é válido.',
  'over.hotovo': 'Seu e-mail está confirmado.',
  'over.odkazVyprsel': 'O link de confirmação não é válido ou expirou.',
  'over.overuji': 'Confirmando seu e-mail…',
  'over.cekejte': 'Aguarde um momento.',
  'over.overen': 'E-mail confirmado.',
  'over.plnyPristup': 'Agora você tem acesso completo a tudo no Bloom.',
  'over.prejitNaBloom': 'Ir para o Bloom',
  'over.selhalo': 'A confirmação falhou',
  'over.zpetNaPrihlaseni': 'Voltar para o login',
  'oauth.ucetNenalezen': 'Conta não encontrada',
  'oauth.neexistujeGoogle': 'Não existe conta do Bloom para esta conta do Google. Cadastre-se primeiro.',
  'oauth.neexistujeFacebook': 'Não existe conta do Bloom para esta conta do Facebook. Cadastre-se primeiro.',
  'oauth.registrovatGoogle': 'Cadastrar-se com o Google',
  'oauth.registrovatFacebook': 'Cadastrar-se com o Facebook',
  'oauth.prihlasujiGoogle': 'Entrando com o Google…',
  'oauth.prihlasujiFacebook': 'Entrando com o Facebook…',
  'oauth.facebookSelhalo': 'Não foi possível entrar com o Facebook',

  // ── drobnosti ─────────────────────────────────────────────────────────────
  'obecne.nacitam': 'Carregando…',
  'obecne.nezadano': '— não informado —',
  'obecne.neplatnaHodnota': 'Esse valor não é válido.',
  'obecne.strankovani': 'Paginação',
  'navrh.doplnteNazev': 'Preencha o nome.',
  'navrh.vyberteZemi': 'Escolha um país.',
  'navrh.doplnte': (p) => `Preencha: ${p.co}.`,
  'kat.overenoZaznam': 'Verificado que o registro confere com a realidade',
  'kat.prihlaskyDo': (p) => `Inscrições até ${p.datum}`,

  'up.odznakAdmin': 'Admin',

  'profil.zalozkaProfil': 'Perfil',
  'profil.zalozkaGalerie': 'Galeria',
  'pf.lokalita': 'Local',

  'cesta.legendaBarev': 'Legenda de cores',

  'hled.pocetVysledku': (p) => `(${p.pocet} ${p.pocet === 1 ? 'resultado' : 'resultados'})`,

  // ── avataři ───────────────────────────────────────────────────────────────
  'avatar.fem-pink': 'Cabelo loiro comprido',
  'avatar.fem-lavender': 'Cabelo roxo',
  'avatar.fem-peach': 'Chanel com franja',
  'avatar.fem-dark': 'Cabelo escuro comprido',
  'avatar.fem-straight': 'Cabelo ruivo',
  'avatar.fem-ponytail': 'Rabo de cavalo',
  'avatar.masc-blue': 'Cabelo loiro curto',
  'avatar.masc-teal': 'Cabelo bagunçado',
  'avatar.masc-gray': 'Cabelo grisalho',
  'avatar.masc-short': 'Corte máquina',
  'avatar.nb-mint': 'Cabelo verde-menta',
  'avatar.nb-lilac': 'Coque alto',
  'avatar.nb-curly': 'Cachos curtos',
  'avatar.nb-sage': 'Cabelo até os ombros',
  'avatar.nb-mohawk': 'Moicano',
  'avatar.nb-undercut': 'Undercut',
  'avatar.nb-shaved': 'Cabeça raspada',
  'avatar.nb-glasses': 'Óculos',
  'avatar.animal-cat': 'Gato',
  'avatar.animal-fox': 'Raposa',
  'avatar.animal-rabbit': 'Coelho',
  'avatar.sym-flower': 'Flor',
  'avatar.sym-butterfly': 'Borboleta',
  'avatar.sym-star': 'Estrela',
  'avatar.custom': 'Enviar minha própria foto',

  // ── odhlášení po nečinnosti ───────────────────────────────────────────────
  'odhl.necinnost': 'Desconectamos você depois de um tempo sem uso.',
  'odhl.necinnostPopis': 'O Bloom não deixa a sessão aberta quando não tem ninguém.',
  'odhl.zaChvili': 'Vamos te desconectar daqui a pouco',
  'odhl.zaChviliPopis': 'Toque na tela ou no teclado a qualquer momento e a sessão continua.',

  'reg.avatarSymboly': 'Símbolos',

  'avatar.fem-bun': 'Coque',
  'avatar.masc-navy': 'Barba cheia',
  'avatar.masc-brown': 'Risca ao lado',
  'avatar.masc-goatee': 'Cavanhaque',
  'avatar.nb-freckles': 'Sardas',
  'avatar.animal-panda': 'Panda',
  'avatar.animal-owl': 'Coruja',
  'avatar.sym-rainbow': 'Arco-íris',
  'avatar.sym-heart': 'Coração',
  'avatar.sym-lotus': 'Lótus (Bloom)',

  'reg.potvrditHeslo': 'Confirmar a senha',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vytvorit': 'Criar',
  'obecne.sdilet': 'Partilhar',
  'obecne.opravneni': 'Permissão',
  'obecne.pristupGalerie': 'Precisamos de aceder às tuas fotos para enviar uma imagem.',
  'obecne.vsechnyRegiony': 'Todas as regiões',
  'obecne.cesko': 'Chéquia',
  'obecne.odbornici': 'Profissionais',
  'obecne.zadnaZprava': 'Sem mensagens',
  'ucet.vyplnteEmailHeslo': 'Introduz o teu e-mail e palavra-passe',
  'ucet.spatneUdaje': 'E-mail ou palavra-passe incorretos',
  'ucet.googleSelhalo': 'Não foi possível entrar com o Google',
  'ucet.skrytHeslo': 'Ocultar palavra-passe',
  'ucet.emailOveren': 'O teu e-mail foi verificado.',
  'ucet.emailPriklad': 'tu@email.com',
  'ucet.overeniSelhalo': 'A verificação falhou.',
  'ucet.overeniSelhaloZnovu': 'A verificação falhou. Tenta novamente.',
  'ucet.komunitniHesloPovinne': 'A palavra-passe da comunidade é obrigatória',
  'ucet.zadejteKomunitniHeslo': 'Introduz a palavra-passe da comunidade…',
  'ucet.komunitniHesloPopis': 'O Bloom é um espaço privado. Alguém da comunidade pode dar-te a palavra-passe.',
  'ucet.prezdivkaMin3': 'O nome deve ter pelo menos 3 caracteres',
  'ucet.vyplntePrezdivku': 'Introduz um nome',
  'ucet.vasePrezdivka': 'O teu nome',
  'ucet.profilNeulozen': 'Não foi possível guardar o perfil',
  'ucet.anoZrusitProfil': 'Sim, eliminar o meu perfil',
  'heslo.min8': 'A palavra-passe deve ter pelo menos 8 caracteres',
  'heslo.maleP': 'A palavra-passe deve incluir uma minúscula',
  'heslo.velkeP': 'A palavra-passe deve incluir uma maiúscula',
  'heslo.cislo': 'A palavra-passe deve incluir um número',
  'heslo.specialni': 'A palavra-passe deve incluir um carácter especial',
  'heslo.specialniPriklad': 'A palavra-passe deve incluir um carácter especial (!@#$%)',
  'heslo.napoveda': 'Mín. 8 caracteres, maiúscula, número, especial',
  'profil.oSobe': 'Um pouco sobre ti…',
  'profil.zajmenaOna': 'ela/dela',
  'profil.zajmenaJine': 'outro',
  'profil.doplnujiciText': 'Nota adicional opcional…',
  'profil.prikladOboru': 'p. ex. cirurgia plástica, direito da família…',
  'komunita.soukromiNadpis': 'Protegemos a privacidade',
  'komunita.soukromiText': 'O que é partilhado no Bloom fica no Bloom.',
  'komunita.podporaText': 'O Bloom é sobre apoio mútuo.',
  'komunita.neniObchod': 'O Bloom não é uma plataforma comercial.',
  'komunita.zadneObtezovani': 'Assédio de qualquer tipo não tem lugar no Bloom.',
  'komunita.oslovovani': 'Tratamos cada pessoa pelo nome e pelos pronomes que usa.',
  'komunita.jakakolivEtapa': 'Onde quer que estejas no teu caminho.',
  'prav.kategZdravi': 'Saúde',
  'prav.kategPravni': 'Jurídico',
  'prav.kategSocialni': 'Social',
  'ot.chybaOdpoved': 'Não foi possível enviar a resposta.',
  'ot.chybaOtazka': 'Não foi possível publicar a pergunta.',
  'zk.napisteKomentar': 'Escreve um comentário…',
  'zpr.chybaHlasova': 'Não foi possível enviar a mensagem de voz. Servidor:',
  'zpr.chybaObrazek': 'Não foi possível enviar a imagem. Servidor:',
  'pod.nabizim': 'Ofereço',
  'pod.coHledate': 'O que procuras? (p. ex. massagens, fotografia…)',
  'pod.coNabizite': 'O que ofereces? (p. ex. cozinha, cabeleireiro…)',
  'pod.lokalitaVolitelna': 'Localidade (opcional)',
  'pod.podrobnejsiPopis': 'Descrição mais detalhada *',
  'pod.vyplnteHledate': 'Indica o que procuras.',
  'pod.vyplnteNabizite': 'Indica o que ofereces.',
  'pod.vyplntePopis': 'Acrescenta uma descrição.',
  'pod.zadnePrispevky': 'Ainda não tens publicações. Cria uma oferta ou um pedido.',
  'svet.vybratZemi': 'Escolher país',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ot.pridat': 'Fazer uma pergunta',
  'ot.nadpis': 'Perguntas e respostas',
  'zk.pridat': 'Acrescentar uma história',
  'zk.novy': 'Nova história',
  'zk.smazat': 'Eliminar história',
  'zk.zadne': 'Ainda não há histórias. Sê a primeira pessoa a partilhar.',
  'akt.zadne': 'Ainda não há notícias.',
  'nav.clanky': 'Artigos',
  'ucet.emailOdeslan': 'E-mail enviado',
  'ucet.komunitniHeslo': 'Palavra-passe da comunidade',
  'ucet.nemateUcet': 'Ainda não tens conta? Regista-te',
  'ucet.muzetePrihlasit': 'Já podes iniciar sessão.',
  'ucet.zapomenutePopis': 'Introduz o teu e-mail e enviamos-te uma ligação para redefinir a palavra-passe.',
  'profil.oMneVolitelne': 'Sobre mim (opcional)',
  'profil.prezdivka': 'Nome',
  'profil.telefonVolitelne': 'Telefone (opcional)',
  'cesta.poznamkaVolitelna': 'Nota pessoal (opcional)',
  'okoli.vyberteLokalitu': 'Escolhe uma localidade acima',
  'hled.nadpis': 'Pesquisa',
  'hled.popis': 'Pesquisa em toda a aplicação: pessoas, artigos, histórias, avaliações…',
  'hled.min2': 'Escreve pelo menos 2 caracteres para pesquisar',
  'pod.vsechnySluzby': 'Todos os serviços',
  'domu.clenoveKomunity': 'Membros da comunidade',
  'zpr.zadneKonverzaceHledat': 'Ainda não há conversas. Procura alguém acima.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'reg.zajmenaOn': 'ele/dele',
  'reg.zajmenaOni': 'elu/delu',
  'reg.zajmenaOno': 'ile/dile',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.smazatFotku': 'Eliminar foto',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.nastavteHeslo': 'Define uma palavra-passe para a galeria',
  'reg.min3znaky': 'Mín. 3 caracteres',
  'reg.zopakujteHeslo': 'Repete a palavra-passe',
  'hled.vBloom': 'Pesquisar no Bloom…',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'profil.upravitProfil': 'Editar perfil',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vybratRegion': 'Escolher região',
  'obecne.region': 'Região',
  'gal.heslemChranena': 'Protegida por palavra-passe',
  'gal.hesloGalerie': 'Palavra-passe da galeria',
  'reset.nastavitHeslo': 'Definir palavra-passe',
  'reset.hesloObnoveno': 'Palavra-passe redefinida.',
  'profil.nenalezen': 'Perfil não encontrado',
  'obecne.nebo': 'ou',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'auth.dvfNapoveda': 'Abre a tua aplicação de códigos e copia os seis dígitos do Bloom. Também podes usar um dos códigos de reserva.',
  'auth.sifrovaniNapoveda': 'Se ativaste a encriptação de mensagens na web, a aplicação ainda não consegue entrar nessa conta. Usa o bloomapp.cz no navegador.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ucet.zobrazitHeslo': 'Mostrar palavra-passe',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.opravduSmazat': 'Eliminar esta foto?',
  'dvf.zadejteKod': 'Introduz o código da tua aplicação',
  'sif.odemknoutAplikaci': 'Desbloquear a aplicação',
  'profil.odeslatZnovu': 'Enviar novamente',
};

export default pt;
